{
  "CCPADontSellButton": "Ne vendez pas et ne partagez pas mes renseignements personnels",
  "ConfirmImHere": "Confirmez votre arrivée",
  "NewAddressAdding": "L'unité peut être saisie à l'étape suivante",
  "RemoveDeliveryAddressConfirmation": "Supprimer la confirmation d'adresse de livraison",
  "about": "À propos",
  "aboutTheApp": "À propos de l'appli",
  "above": "ci-dessus",
  "accept": "Accepter",
  "acceptAllCookies": "Accepter tous les témoins",
  "acceptEmailsAndSpecialOffers": "Je souhaite recevoir par courriel des informations et des offres spéciales de Burger King",
  "acceptGiftError": "Veuillez réessayer plus tard ou communiquez avec le service de soutien à {supportLink}, ou par téléphone au 1-888-601-1616.",
  "acceptGiftSuccess": "{fullName} vous a envoyé le cadeau suivant : {gift}. Le cadeau a été ajouté à votre compte et apparaîtra avec les autres offres. N’oubliez pas de l’activer.",
  "acceptGiftSuccessHeading": "Vous avez reçu un cadeau!",
  "acceptOrDecline": "Accepter ou Rejeter cette commande",
  "acceptOrder": "Accepter la commande",
  "acceptOrderModal": "Ayez cette commande prête pour {serviceMode} à {time} le {date}. Vous ne serez pas en mesure de rejeter une commande après l'avoir acceptée ici.",
  "acceptRollsCongrats": "Félicitations!",
  "acceptRollsModalHeader": "Vous avez reçu {numberOfRollsShared, plural, one {un} other {{numberOfRollsShared}}} REBORD{numberOfRollsShared, plural, one {} other {S}}!",
  "acceptTermsAndPrivacyIntro": "J'accepte la: {privacyPolicyLink}, {rewardsPolicyLink}, {termsOfServiceLink}",
  "accessibility": "Accessibilité",
  "accessibilityMode": "Mode d'accessibilité",
  "account": "Compte",
  "accountDefault": "défaut",
  "accountDetails": "Détails du compte",
  "accountInfo": "Infos sur le compte",
  "accountRewardsPoints": "Tu détiens {points} Couronnes.",
  "accountRewardsPointsExpiration": "{pointsToExpire} Couronnes expireront le {expirationDateTime}",
  "accountWithEmailAlreadyExists": "Un compte avec cette adresse courriel existe déjà ",
  "activate": "Activer",
  "activateOffer": "Activer l'offre",
  "activated": "Activée",
  "activationFailed": "Activation échouée",
  "add": "Ajouter",
  "addCreditCard": "Ajouter une Carte de crédit",
  "addCreditDebitCard": "Ajouter Carte de Crédit / Débit",
  "addExtras": "Ajouter quelque chose",
  "addFavorite": "Ajoute un favori",
  "addGiftCardError": "Nous n'avons pas pu créer une Carte Tim numérique. Votre mode de paiement n'a pas été facturé. Veuillez réessayer ou appuyer sur {link}.",
  "addItemLabel": "Ajouter 1 {itemName} à votre panier",
  "addItemToCart": "Ajouter {name} au panier",
  "addItemToCartWithModifiers": "Ajouter {name} avec  {modifiers} au panier",
  "addItems": "Ajouter des produits",
  "addItemsLowerCase": "Ajouter des produits",
  "addMobileOrder": "Ajouter à la commande mobile",
  "addNewCard": "Carte de débit ou de crédit",
  "addNewCreditCard": "Ajouter une nouvelle carte de crédit",
  "addNewPaymentMethod": "Ajouter un mode de paiement",
  "addNewPaymentMethodGiftCard": "Ajoutez carte BK Crown",
  "addOffers": "Ajouter offres",
  "addOne": "Ajouter un",
  "addOneItemToCart": "Ajouter 1 {itemName} to cart",
  "addOneName": "Ajouter un {name}",
  "addPayment": "Ajouter carte",
  "addPaymentMethod": "Ajouter carte",
  "addPaymentMethodOrReload": "Ajouter une nouvelle carte",
  "addPrepaidCard": "Ajoutez une carte BK Crown",
  "addQuantityAndItemToCart": "Ajouter {quantity} {itemName} au panier",
  "addQuantityAndItemWithPrice": "Ajouter {quantity} {itemName} à la commande pour {price}",
  "addReloadMethod": "Ajouter une méthode de réapprovisionnement",
  "addRewards": "Ajouter recompenses",
  "addSomethingExtra": "Ajoutez un produit pour compléter votre commande",
  "addSpecificInstructions": "Ajoutez toute information supplémentaire ici",
  "addTag": "Ajouter une étiquette",
  "addTimCard": "Ajouter une Carte Tim",
  "addToAppleWalletAlt": "Ajouter à Apple Wallet",
  "addToCart": "Ajouter",
  "addToCartCarousel": "Ajouter au panier",
  "addToCartError": "Impossible d'ajouter à la commande. Svp essayer de nouveau.",
  "addToCartSuccess": "{itemName} ajouté au panier.",
  "addToGooglePayAlt": "Ajouter à Google Pay",
  "addToInRestaurantRedemptionCartSuccess": "{type} sauvegardée et à réclamer en restaurant.",
  "addToOrder": "Ajouter à la commande",
  "addToOrderHeader": "Ajouter à la commande",
  "additionalAddressInformation": "Jusqu'à peut être renseigné au moment du paiement",
  "additionalInstructions": "Directives additionnelles",
  "addons": "Petis ajouts",
  "address": "Adresse",
  "addressError": "Oups! Adresse non reconnue",
  "addressFieldIsRequired": "Vous devez entrer une adresse",
  "addressRequired": "Adresse (Obligatoire)",
  "addressRequiredError": "Vous devez entrer une adresse",
  "adjustQuantityOfItem": "Ajuster la quantité de {item name}",
  "adsPersonalization": "Publicité ciblée par centres d’intérêt",
  "adsPersonalizationInfo": "Si cette option est activée, nous pourrions partager vos coordonnées et l’identifiant de votre appareil avec des médias sociaux et d’autres plates-formes de tiers afin de nous aider à diffuser des publicités et des offres susceptibles de vous intéresser, ou en intéresser d’autres. Vous pouvez vous désinscrire à tout moment, mais notez que cela pourrait entraîner des répercussions sur la pertinence des publicités et des offres que vous recevrez. Pour en savoir davantage, veuillez consulter {privacyPolicyLink}.",
  "afterDiscount": "Après réduction",
  "afterSevenPurchases": "Après chaque série de sept achats, vous pouvez obtenir votre récompense.",
  "agreeToTermsOfService": "J’accepte les modalités d’utilisation",
  "agreeToTermsOfServiceError": "Vous devez accepter la politique de confidentialité et les conditions d'utilisation avant de vous inscrire.",
  "agreeToTheFollowing": "J'accepte ce qui suit :",
  "aliasAutoRenamed": "L'alias sélectionné a déjà été utilisé et a été renommé automatiquement.",
  "aliasError": "Veuillez sélectionner une étiquette (Domicile, Travail ou Autre).",
  "aliasLabelHome": "Domicile",
  "aliasLabelOther": "Autre",
  "aliasLabelWork": "Travail",
  "allMenu": "Menu Tout",
  "allRightsReserved": "Tous droits réservés.",
  "allSetCustomer": "C’est tout, {firstName}!",
  "allergenInformation": "Renseignements sur les allergènes",
  "allergensDisclaimer": "Ce produit {allergenContents}. Les modifications ne sont pas reflétées dans cette liste.",
  "allergensDisclaimerContains": "Ce produit contient {allergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerContainsAndMayBeCookedOn": "Ce produit contient {allergens} et être préparé sur les mêmes appareils que {maybeCookedOnAllergens}. Les modifications ne sont pas représentées dans cette liste.",
  "allergensDisclaimerContainsAndMayContain": "Cet article contient {allergens} et peut contenir des traces de {maybeAllergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerContainsAndMayContainAndMayBeCooked": "Cet article contient {allergens}, peut contenir des traces de {maybeAllergens} et être préparé sur les mêmes appareils que {maybeCookedOnAllergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerMayBeCookedOn": "Ce produit peut être cuit sur le même équipement utilisé pour cuire ce qui suit : {maybeCookedOnAllergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerMayContain": "Ce produit peut contenir {maybeAllergens}. Les modifications ne sont pas reflétées dans cette liste.",
  "allergensDisclaimerMayContainAndMayBeCookedOn": "Ce produit peut contenir ce qui suit : {maybeAllergens}. Il peut également être cuit sur le même équipement utilisé pour cuire ce qui suit : {maybeCookedOnAllergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerUnknown": "Ce produit peut contenir des allergènes",
  "allergensDownloadPDF": "Allergènes",
  "allergensViewInBrowser": "Allergènes - Consulter dans le navigateur",
  "allergicTo": "Je suis allergique à",
  "allowLocationServices": "Autoriser les services de localisation",
  "allowLocationServicesToFind": "Autoriser les services de localisation à trouver",
  "alreadyHaveAPhysicalCard": "Vous avez déjà une carte physique?",
  "alreadyHaveAnAccount": "Vous avez déjà un compte?",
  "alreadyLinkedACard": "Avez-vous déjà associé une carte?",
  "amount": "quantité",
  "amountMore": "+{amountMore} autre(s)",
  "and": "et",
  "andConjunction": "{first} et {second}",
  "answer": "Réponse",
  "anyQuestionsHeading": "Des questions?",
  "apartment": "Appartement",
  "appImage": "Image de l'appli",
  "appUpdateRecommended": "Mise à jour de l’appli recommandée",
  "appUpdateSubtext": "Nous vous recommandons d’installer la plus récente version de notre appli avant de passer votre commande. Voulez-vous mettre l’appli à jour maintenant?",
  "appflowCompleted": "Mise à jour terminée!",
  "appflowDownloading": "Téléchargement de la mise à jour.",
  "appflowError": "Un problème est survenu lors du téléchargement de la mise à jour.",
  "appflowExtracting": "Extraction de la mise à jour.",
  "appflowProgress": "{progress} terminé.",
  "applePay": "Paiement Apple",
  "applePayPaymentNotAvailable": "Nous n’acceptons pas en ce moment les paiements Apple Pay sur nos sites Web. Veuillez sélectionner ou ajouter un nouveau type de paiement.",
  "apply": "Appliquer",
  "applyAReward": "Utiliser une récompense",
  "approve": "Confirmer",
  "approxMinutesAway": "(Dans 5 minutes environ)",
  "april": "Avril",
  "aptOrSuite": "Appartement ou bureau",
  "areDeliveryDetailsValid": "Nous ne sommes pas en mesure de confirmer votre numéro de téléphone. Veuillez confirmer que votre numéro de téléphone est correct ou en essayer un autre.",
  "asap": "Dès que possible",
  "at": "au",
  "atARestaurant": "À un restaurant",
  "atRestaurantDetails": "Cela inclut les commandes à emporter, à manger en restaurant, et plus encore",
  "attachedToMyCodeSuccess": "{type} liée à Mon Code.",
  "august": "Août",
  "authContinueSubHeader": "Voulez-vous continuer dans l’appli ou sur le site Web?",
  "authContinueWeb": "Continuer sur le site Web",
  "authEmailCheckYourEmail": "Vérifiez votre boîte de courriel",
  "authEmailSentEmail": "Nous avons envoyé un courriel contenant des instructions de connexion à",
  "authEmailTimeToReceive": "Le courriel peut prendre jusqu'à 3 minutes avant d'arriver dans votre boîte.{separator}Cliquez sur le lien fourni dans le message pour ouvrir une session.",
  "authEnterCode": "Entrez Le Code De Vérification Ci-Dessous:",
  "authError": "Une erreur s'est produite lors de la connexion",
  "authExpiredLink": "Votre lien est peut-être expiré ou vous utilisez un navigateur différent. Demandez un nouveau lien en appuyant sur le bouton «{sendNewLinkText}» ci-dessous.",
  "authMissingLink": "Nous sommes désolés. Nous ne trouvons pas ce lien.",
  "authNewLink": "Envoyer un nouveau lien",
  "authRetryError": "Une erreur s’est produite. Appuyez ci-dessous pour réessayer.",
  "authVerifyWithCode": "Vérifiez avec un code",
  "autoReload": "Réapprovisionnement automatique",
  "autoReloadDefaultAmount": "Utilisez la carte {cardType} se terminant par {alias} pour la réapprovisionner de ce montant :",
  "autoReloadDetails": "Avec le réapprovisionnement automatique, vous pouvez ajouter automatiquement de l'argent à votre Carte Tim lorsque le solde de votre compte est trop bas.",
  "autoReloadPleaseSelectAFundingSource": "Veuillez sélectionner une source de fonds",
  "autoReloadThreshold": "Lorsque le solde de ma Carte Tim est inférieur à :",
  "autoSignInSuccess": "Félicitations! Votre compte a été créé.",
  "available": "Disponible",
  "availableCrowns": "Couronnes disponibles",
  "availableForDelivery": "Commande pour livraison seulement",
  "availableForPickUp": "Cueillette de commande seulement",
  "availablePoints": "Couronnes disponibles",
  "back": "Précedent",
  "backToMenu": "Retourner au menu",
  "backToOffers": "Retourner aux offres",
  "backToSavedAddresses": "Retour aux adresses sauvegardées",
  "backToSummary": "Retour au résumé",
  "backToTopics": "Retour aux sujets",
  "backgroundImage": "Image d’arrière-plan",
  "backwardButton": "Bouton Précédent",
  "badNetworkDialogBody": "Afin d’accéder à toutes les fonctionnalités de l’appli, veuillez vous déplacer dans une zone où le signal Internet est plus fort et essayez de nouveau.",
  "bagEmpty": "Votre sac est vide",
  "balanceNoCoverCostReloadToContinue": "Le solde actuel de votre Carte Tim n'est pas suffisant pour couvrir le coût de votre commande aujourd'hui. Réapprovisionnez votre Carte Tim pour continuer.",
  "balanceReloadAmount": "Montant du rechargement de solde",
  "balanceTransfer": "Transfer de solde",
  "bankMyRewards": "Sauvegarder mes Couronnes",
  "bankingPoints": "Sauvegarder mes points",
  "below": "ci-dessous",
  "billingAddressIsSameAsDeliveryAddress": "L’adresse de facturation est la même que l’adresse de livraison.",
  "billingCountryIsARequiredField": "L’adresse de facturation est requise",
  "bk.payWithMyPrepaidCard": "Payez avec la carte BK Crown",
  "bk.pypestreamLoadingMessage": "Un moment pendant que nous activons le soutien.",
  "bk.routes.privacyPolicy": "/politique-confidentialite",
  "bk.routes.termsOfService": "/conditions-d-utilisation",
  "bkCareers": "Emplois BK",
  "bkKingdom": "BK Kingdom",
  "bkRewards": "Récompenses BK",
  "bk_aboutBK": "À propos de BK",
  "bk_allRightsReserved": "Tous droits réservés",
  "bk_bkApp": "Appli BK",
  "bk_bkCares": "BK se sent concerné",
  "bk_bkMcLAMOREFoundation": "Fondation BK McLAMORE",
  "bk_bkTrademarkAndCopyright": "TM et droits d'auteur 2021 Burger King Corporation.",
  "bk_bkcInfo": "Info BKC",
  "bk_bringItUpAtBKC": "Apportez-le @ BK",
  "bk_giftOrCrownCard": "Cartes cadeau/Carte Crown",
  "bk_logo_title": "Burger King",
  "bk_myBK": "Mon  BK",
  "bk_nutritionExplorer": "Explorateur Nutrition",
  "bk_pointsBalance": "Récompenses BK Crown :",
  "bonus": "Bonus",
  "bonusPointsLabel": "Couronnes en prime",
  "breakfastDayPartEnds": "Le déjeuner prend fin dans {minutes} min",
  "breakfastDayPartHours": "Déjeuner ofert jusqu’à {endDateHours}",
  "breakfastDisclaimer": "Produits offerts à la période du déjeuner seulement",
  "breakfastMenu": "Menu déjeuner",
  "browseOpportunities": "Voir les occasions ",
  "browseOurMenu": "Parcourir notre menu",
  "browserSettings": "Paramètres du navigateur",
  "bsmConfirmationModalBody": "Vous devrez choisir un nouveau mode de service et un nouveau restaurant, ou une nouvelle adresse de livraison.",
  "bsmConfirmationModalHeading": "Voulez-vous vraiment changer votre restaurant?",
  "button": "bouton",
  "byDefault": "Par défault",
  "cal": "cal",
  "calculatingEta": "Calcul de l'emplacement du livreur",
  "calories": "Calories",
  "canada": "Canada",
  "cancel": "Annuler",
  "cancelCTA": "Annuler",
  "cancelOrder": "Annuler la commande",
  "cancellationPolicy": "Aucun changement ne peut être apporté à votre commande après l’avoir passée.",
  "cancellationPolicyTitle": "Politique d’annulation",
  "cancelledOrderAction": "Nous sommes désolés, mais il semblerait que votre commande a été annulée et remboursée. Si vous voulez passer votre commande à nouveau, vous pouvez utiliser le bouton ci-dessous",
  "cancelledOrderTitle": "Oh non! Votre commande a été annulée.",
  "cannotDeliveryTo": "Actuellement nous ne pouvons pas faire de livraison à ",
  "cannotPlaceOrder": "Nous n'avons pas pu passer votre commande. Fermez ce message pour trouver d'autres restaurants à proximité.",
  "carbohydrates": "Glucides",
  "carbs": "Glucides",
  "card": "CARTE",
  "cardAddedNotification": "Carte ajoutée!",
  "cardCurrenciesDontMatch": "La Carte Tim que vous essayez de transférer est d'une région différente de celle de votre compte. Vous ne pouvez transférer que des Cartes Tim provenant de votre région.",
  "cardDeactivationError": "Nous n'avons pas pu traiter votre demande. Veuillez réessayer ou appuyer sur {link} pour obtenir de l'aide.",
  "cardExpiration": "Date d'expiration de la carte",
  "cardNumber": "Numéro de carte",
  "cardNumberIsRequired": "Vous devez entrer le numéro de la carte",
  "cardNumberRequiredError": "Vous devez entrer le numéro de la carte",
  "cardXHasABalanceOfY": "La carte {cardNumber} a un solde de {balance}.",
  "careers": "Carrières",
  "careersHome": "Accueil Emplois",
  "cart": "Panier",
  "cartCardLoadingMessage": "Nous préparons ta commande…",
  "cartCardLoadingSuccess": "Succès!",
  "cartCloseConfirmDialogHeading": "Ta commande est en cours",
  "cartConfirmDialogBody": "Nous nous en occupons! Nous vous invitons à parcourir notre appli pendant que nous traitons votre commande.",
  "cartConfirmDialogConfirmLabel": "D’accord",
  "cartLoyaltyPoints": "Vous avez {points} Couronnes",
  "cartOfferRequirementsNotMetError": "Les articles de votre panier ne répondent pas aux exigences de cette offre",
  "cartTotal": "Total du panier",
  "cartV2_incentiveFeedbackSubtotal": "Un achat minimum de {targetValue} $ est requis",
  "cash": "Argent",
  "cashPayementsAcceptedAtTheCounter": "Les paiements en argent seront effectués au comptoir",
  "ccNumberIsNotValid": "Le numéro de la carte n'est pas valide",
  "celery": "céleri",
  "challenge": "Défi",
  "challengeComplete": "Défi complété",
  "challengeCompleted": "Défi complété",
  "challengeStarted": "Le défi est lance",
  "change": "Changer",
  "changeAddress": "Changer Adresse",
  "changeAddressAriaLabel": "Lien pour changer l’adresse de l’emplacement",
  "changeFundingSource": "{method} Source des fonds",
  "changeLanguage": "Sélectionner de Langue et Région",
  "changePaymentMethod": "Ce restaurant n'accepte pas ce type de carte. Changez votre mode de paiement et réessayez.",
  "changeRedemptionToInStore": "Êtes-vous certain de vouloir passer à une réclamation en restaurant?",
  "changeRedemptionToInStoreConfirmLabel": "Passer à en restaurant",
  "changeRedemptionToInStoreDescription": "Votre panier sera supprimé si vous passez à une réclamation en restaurant. Souhaitez-vous vraiment continuer?",
  "changeRedemptionToPickUp": "Êtes-vous certain de vouloir passer à une commande mobile?",
  "changeRedemptionToPickUpConfirmLabel": "Passer à une commande mobile",
  "changeRedemptionToPickUpDescription": "En passant d’une réclamation en restaurant à une commande mobile, vous supprimerez vos récompenses actives. Voulez-vous procéder?",
  "changeRegionConfirmation": "Veuillez confirmer votre région pour continuer.",
  "changeRegionDisclaimer": "Veuillez noter que vous devrez sélectionner votre restaurant à nouveau.",
  "changeRegionOnOrder": "Nous devons mettre à jour votre pays pour que vous puissiez commander de ce restaurant. Veuillez sélectionner la langue appropriée",
  "changeRestaurantDialogBody": "Changer le restaurant pourrait entraîner des changements aux prix et produits disponibles.",
  "changeRestaurantDialogConfirmButtonLabel": "Changer Restaurant",
  "changeRestaurantDialogHeading": "Changer Restaurant?",
  "changeServiceMode": "Modifier le mode de service",
  "changeStoreAriaLabel": "Lien pour changer de restaurant",
  "changeStoreItemDisclaimer": "Les prix et la disponibilité des produits peuvent varier d’un restaurant à l’autre.",
  "changeStoreMessage": "Changer le restaurant pourrait entraîner des changements aux prix et produits disponibles. Voulez-vous poursuivre avec le changement de restaurant?",
  "changeStoreMessagePromptDisclaimer": "Changer le restaurant pourrait entraîner des changements aux prix et produits disponibles.",
  "changeStoreSelectedOfferAndItemDisclaimer": "L’offre que vous avez sélectionnée n’est pas disponible pour la {serviceMode}. Les prix et la disponibilité des produits peuvent varier d’un restaurant à l’autre.",
  "changeStoreSelectedOfferDisclaimer": "L’offre que vous avez sélectionnée n’est pas disponible pour la {serviceMode}.",
  "changeStores": "Changer le restaurant",
  "chatWithUs": "clavarder avec nous",
  "checkAvailability": "Vérifier la disponibilité",
  "checkCardBalance": "Vérifier le solde de la carte",
  "checkNetworkSettings": "Veuillez vérifier vos paramètres réseau et réessayer",
  "checkingDeliveryAvailability": "Nous vérifions la disponibilité du service de livraison.",
  "checkingDeliveryAvailabilityText": "Nous cherchons quel restaurant livrera à votre adresse. Cela pourrait prendre quelques instants.",
  "checkingPricesAvailability": "Vérifier les prix et la disponibilité",
  "checkingWithRestaurant": "Nous vérifions auprès du restaurant.",
  "checkout": "Caisse",
  "checkoutPaymentMethodNeedRevaultError": "Une erreur s’est produite lors du traitement de votre mode de paiement. Veuillez rajouter votre mode de paiement.",
  "cholesterol": "Cholestérol",
  "chooseADifferentPaymentMethodByPressingCancel": "Vous pouvez choisir un mode de paiement différent en appuyant sur le bouton Annuler sur le clavier NIP.",
  "chooseALocation": "Choisir un restaurant",
  "chooseAnOption": "Choisissez une option...",
  "chooseDifferentItem": "Veuillez sélectionner un autre produit.",
  "chooseDifferentOffer": "Veuillez sélectionner une autre offre.",
  "chooseDrink": "Ensuite, choisissez une boisson",
  "chooseItemAmount": "Choisissez {amount} {itemName}",
  "chooseLocation": "Choisir la localisation",
  "chooseMyRewardLevel": "Choisir mon niveau de récompense",
  "choosePaymentMethod": "Choisir la méthode de paiement",
  "chooseSide": "Ensuite, choisissez un accompagnement",
  "chooseTheDefaultAmountToReloadYourGiftCard": "Choisissez le montant par défaut du réapprovisionnement de la Carte Tim",
  "chooseYourLocation": "Choisir un resto",
  "chooseYourRewardLevel": "Choisissez votre niveau de récompenses",
  "city": "Ville",
  "cityRequiredError": "Vous devez entrer une ville",
  "claimPoints": "réclamer les Couronnes",
  "clearFilter": "supprimer filtre",
  "clearSearchBar": "Supprimer le contenu de la barre de recherche",
  "clearText": "Effacer le texte",
  "clickHere": "Cliquez ici",
  "clickHereForDetails": "Cliquez ici pour plus de détails",
  "clickToSelectLocation": "Sélectionner le restaurant",
  "close": "Fermer",
  "closeDialog": "Fermer la fenêtre de dialogue",
  "closeMessageToFindNearbyRestaurants": "Fermez ce message pour trouver d'autres restaurants à proximité",
  "closeMessageToFindNearbyStores": "Revenez en arrière pour trouver des restaurants qui proposent la vente sur place (Click&Collect), la vente à emporter ou via le Drive.",
  "closeWindow": "Fermer la fenêtre",
  "closed": "Fermé",
  "closesAt": "Ferme à {time}",
  "closestStoreSelected": "Nous avons sélectionné le restaurant le plus près de votre emplacement actuel.",
  "codeErrorMessage": "Impossible de récupérer votre code.",
  "coffee": "Café",
  "comboOfferSavings": "Économies",
  "combobox": "zone de trios",
  "comeJoinTheTeam": "Joignez-vous à notre équipe",
  "comingSoon": "Bientôt disponible!",
  "comments": "Commentaires",
  "communicationPreferences": "Préférences de communication",
  "community": "Communauté",
  "completed": "Terminé",
  "confettiRight": "Confettis à droite",
  "confirm": "confirmez",
  "confirmAllItemsAreMissing": "Confirmer qu'il manque tous les articles",
  "confirmArrival": "Confirmer l'arrivée",
  "confirmCTA": "Confirmer",
  "confirmDeletePaymentMethod": "Êtes-vous sûr de vouloir supprimer ce mode de paiement?",
  "confirmDialogBody": "Veuillez continuer si vous êtes prêt à réclamer au restaurant",
  "confirmDialogHeader": "Ce bon d’achat expire {br} dans 15 minutes",
  "confirmOnlySomeItemsAreMissing": "Confirmer qu'il ne manque que quelques articles",
  "confirmYourStore": "Confirmez votre restaurant",
  "confirmationDifferentLocation": "Choisissez une autre adresse",
  "confirmationPageInstructions": "Félicitations, nous avons sauvegardé votre commande! Appuyez sur « Je suis ici » quand vous arrivez au restaurant",
  "congratulations": "Félicitations",
  "connectCard": "Connecter la carte",
  "connectWithUs": "Connecte-toi avec nous",
  "contact": "Contacter",
  "contactCourier": "Vous pouvez contacter votre livreur au:",
  "contactRestaurantAt": "Veuillez contacter votre restaurant au:",
  "contactSupport": "Contacter Le Service D'Assistance",
  "contactUs": "Contactez-nous",
  "containsAllergens": "Contient: {allergens}",
  "containsAllergensDisclaimer": "Contient cet ou ces ingrédients : {allergens}",
  "containsSelectedOption": " contient le niveau sélectionné {rewardTier}",
  "contentinfo": "information sur le contenu",
  "continue": "Continuer",
  "continueCustomizing": "Continuer à personnaliser",
  "continueEditing": "Continuer à modifier",
  "continueInWeb": "Dirigez-moi vers le site Web et envoyez-moi un nouveau code",
  "continueOrdering": "Oui, poursuivre la commande",
  "continueToCart": "Continuer au panier ({numberOfItemsInCart})",
  "continueWithEmail": "Accès par Courriel",
  "continueWithOffer": "Continuer avec cette offre",
  "continueWithoutOffer": "Continuer sans l'offre",
  "cookieNotice": "Notice Cookie",
  "cookiePolicy": "En cliquant sur \"{acceptCookies}\", vous acceptez la sauvegarde de témoins sur votre appareil dans le but de rehausser la navigation sur le site et d’analyser l’utilisation du site, en plus de nous aider dans nos efforts de marketing.",
  "cookiePolicyiOS14": "En cliquant sur “Accepter les Cookies”, vous acceptez que les cookies soient sauvegardés sur votre appareil afin d’activer de nouvelles fonctionnalités et nous permettre un meilleur suivi de votre activité. Nous ne suivrons pas votre activité sans votre consentement.",
  "copy": "Copier",
  "couldNotLocateStore": "Il est impossible de localiser le restaurant pour compléter votre commande. Veuillez réessayer plus tard.",
  "couldntProcessOrder": "Veuillez essayer de passer votre commande au restaurant et fournir votre code à 6 chiffres, ou sélectionnez un autre restaurant.",
  "couldntProcessPayment": "Malheureusement, nous n'avons pas réussi à traiter votre paiement. Veuillez revoir les renseignements sur votre carte. Si tout est exact, essayez de soumettre votre commande à nouveau. ",
  "country": "Pays",
  "countryRequiredError": "Le pays est un champ requis.",
  "couponApplied": "Coupon Applied",
  "couponEntryComingSoon": "Bon d’achat à venir sous peu",
  "couponErrorBody": "Votre commande contient un bon qui n'est plus offert. Vous pouvez compléter votre commande, mais nous supprimerons le bon du panier.",
  "couponErrorConfirm": "Compléter la commande",
  "couponErrorHeading": "Erreur relative au bon",
  "couponOnlyAvailableOnPlatform": "Nous sommes désolés. Ce bon d’achat {br} n’est disponible que sur notre plateforme {platformName}",
  "couponWillExpire": "Ce bon expirera dans 15 minutes",
  "createAccountHeadline": "Créez un compte pour commencer",
  "createAnAccount": "Créer un compte",
  "createAnAccountErrors": "Le formulaire a {count, plural, one {# erreur} other {# erreurs}}.",
  "createAnAccountSubheader": "Bienvenue! Vous créez un compte lié à {email}",
  "credit": "Crédit",
  "creditCardExpired": "Le numéro de carte de crédit est expiré",
  "creditCardNumber": "Numéro de carte ",
  "crownCard": "Carte Crown",
  "crowns": "Couronnes",
  "crownsAllYours": "Ça fait {points} Couronnes — à toi !",
  "crownsApplied": "Couronnes appliquées",
  "crownsAwayFromUnlockingMoreRewards": "Couronnes avant de déverrouiller d’autres récompenses",
  "crownsEarnedKeepGoing": "{crowns} couronnes gagnées — continuez !",
  "curbside": "Pickup à l'extérieur",
  "curbsideAt": "Pickup à l'extérieur au",
  "curbsideHours": "Heures d'ouverture pickup à l'extérieur",
  "curbsideInstructionsText": "Annoncez-nous votre arrivée et nous vous apporterons votre commande à votre véhicule dès qu’elle sera prête. Sinon, nous préparerons votre commande à {time}",
  "curbsideInstructionsTextHere": "Nous avons commencé à préparer votre commande. Stationnez dans un endroit désigné dans le stationnement et nous livrerons votre commande à votre véhicule.",
  "curbsideOrder": "Pickup à l'extérieur",
  "curbsideOrderError": "Une erreur s’est produite lors du traitement de votre commande de pickup. Veuillez confirmer vos coordonnées ou essayer un autre mode de service.",
  "curbsideOrderSaved": "Commande de livraison au stationnement sauvegardée",
  "curbsideUnavailable": "Pickup à l'extérieur n'est pas disponible",
  "curbsideVehicleDescription": "Aidez-nous à vous trouver en décrivant votre véhicule; p. ex. VUS rouge. À votre arrivée au restaurant, trouvez un endroit pour vous stationner. Dès que votre commande sera prête, nous vous l’apporterons.",
  "curbsideVehicleDescriptionPlaceholder": "Description du véhicule",
  "curbsideVehicleTitle": "Décrivez votre véhicule",
  "currencyInfo": "Le format de votre devise est déterminé par vos paramètres régionaux. Modifiez vos paramètres régionaux pour mettre à jour votre format.",
  "currentServiceModeUnavailable": "Le restaurant n'accepte pas de commandes {serviceMode} en ce moment. Changez le mode de service ou sélectionnez un autre établissement",
  "currentlyHaveXRewards": "Vous avez actuellement {availableRedemptions} récompenses",
  "customize": "Personnaliser",
  "cvv": "CVV",
  "cvvIsRequired": "Le numéro CVV est requis",
  "cvvMustBeAtLeast3Digits": "Le code CVV doit comporter au moins 3 chiffres",
  "date": "Date",
  "dateOfBirth": "Date de naissance",
  "dateOfBirthIsBelowMinimum": "Les informations renseignées ne sont pas en conformité avec nos {termsLink} et notre {privacyPolicyLink}",
  "dateOfBirthIsRequired": "La date de naissance est un champ obligatoire.",
  "datePlaceholder": "mm/jj/aaaa",
  "day": "Jour",
  "dayPlaceholder": "JJ",
  "daypartAfterEndTime": "La période {dayPart} est terminée!",
  "daypartChallengedCompleted": "Défi complété",
  "daypartEndsAt": "{dayPart} se termine à {endTime}",
  "days": "Jours",
  "daysLeft": "{daysCount} jours restants",
  "daytime": "Pendant la journée",
  "daytimeMenu": "Menu du jour",
  "daytimeMenuHeader": "De {daytimeStartTime} à {daytimeEndTime}",
  "daytimeMenuHeaderHours": "De {daytimeStartTime} à la fermeture",
  "deactivateCard": "Désactivez votre carte",
  "deactivateTimsCard": "Désactiver une carte FidéliTim",
  "debit": "Débit",
  "december": "Décembre",
  "decline": "Rejeter",
  "declineOrder": "Rejeter la commande",
  "declineReason": "Decline reason",
  "defaultReloadMethod": "Méthode de rechargement par défaut",
  "delete": "supprimer",
  "deleteAccount": "Supprimer le compte",
  "deleteButtonText": "Supprimer",
  "deletePaymentMethod": "Supprimer le mode de paiement",
  "deliverHere": "Livrer ici",
  "deliverTo": "Livrer à",
  "delivered": "Livré",
  "deliveringTo": "Livrer à",
  "deliveringToYourDoorAt": "Livraison à votre porte au",
  "delivery": "Livraison",
  "deliveryAddNewAddress": "Ajouter une nouvelle adresse",
  "deliveryAddress": "Adresse de livraison",
  "deliveryAddressFormatted": "{addressLine1}, {city}, {state} {zip}",
  "deliveryCheckingMessage": "Nous cherchons quel restaurant livrera à votre adresse. Attend quelques instants...",
  "deliveryClosed": "Livraison fermée. Sélectionnez une autre adresse",
  "deliveryClosing": "La livraison se termine dans {minutes} min",
  "deliveryComingSoon": "Livraison BIENTÔT DISPONIBLE",
  "deliveryDelivered": "Livrée",
  "deliveryDetails": "Détails de la livraison",
  "deliveryDetailsInstructions": "Directives de livraison",
  "deliveryDriveEnroute": "Votre livreur arrivera bientôt!",
  "deliveryDriverEnroute": "Livreur en route",
  "deliveryFee": "Frais de livraison",
  "deliveryFeeDescription": "Les frais de livraison varient pour chaque restaurant en fonction de votre emplacement et d'autres facteurs.",
  "deliveryFees": "Frais de commande de livraison",
  "deliveryFeesStripeFee": "Livraison",
  "deliveryFeesStripeGeographicalFee": "Restaurant",
  "deliveryFeesStripeSmallCartFee": "Petit panier d’achats",
  "deliveryFeesStripeTitle": "Des frais de livraison s’appliquent",
  "deliveryFeesStripeTitleSuffix": "Commande minimale de {amount}",
  "deliveryImage": "Image de livraison",
  "deliveryInfo": "Renseignements sur la livraison",
  "deliveryInstructions": "Directives de livraison",
  "deliveryIsUnavailable": "La livraison n'est pas offerte dans votre région; mais, cela ne vous empêche pas de savourer nos délicieux produits. Cliquez sur le bouton ci-dessous pour trouver les restaurants dans votre région et rappelez-vous de vérifier nos offres!",
  "deliveryMinumumNotReached": "Nous sommes désolés! Le montant minimal pour une commande de livraison est de {min}",
  "deliveryNotAvailable": "Livraison indisponible",
  "deliveryOrder": "Commande en Livraison",
  "deliveryOrderBeingPrepared": "En préparation",
  "deliveryOrderPlaced": "Commande passée pour livraison",
  "deliveryPhoneDisclosure": "Votre numéro de téléphone est nécessaire afin de nous permettre de vous acheminer les mises à jour liées à votre commande et de faciliter la communication entre vous et votre livreur. Notez que votre numéro de téléphone ne pourra être vu par le livreur.",
  "deliveryPlaced": "Merci. Nous avons reçu votre commande.",
  "deliveryPrepared": "Votre commande est en cours.",
  "deliverySelectYourAddress": "Sélectionnez votre adresse de livraison",
  "deliveryShouldSaveInfoCheckboxMessage": "Sauvegardez mes informations afin de me permettre de recevoir des mises à jour sur ma commande et des communications de la part du livreur. Le livreur ne verra pas votre numéro de téléphone.",
  "deliveryStatusDriverAssigned": "Votre commande est en cours",
  "deliveryStatusDriverAtCustomer": "Votre livreur n’est pas loin!",
  "deliveryStatusDriverAtStore": "Votre livreur vient de ramasser votre commande ",
  "deliveryStatusDriverStarting": "Votre livreur ramasse votre commande",
  "deliveryStatusDriverUnassigned": "Votre commande est en cours",
  "deliveryStatusOrderAbandoned": "Votre commande a été livrée",
  "deliveryStatusOrderCancelled": "Votre commande a été annulée",
  "deliveryStatusOrderCreated": "Votre commande est en cours",
  "deliveryStatusOrderDroppedOff": "Votre commande a été livrée",
  "deliveryStatusOrderError": "Erreur lors du traitement de votre commande",
  "deliveryStatusOrderPickedUp": "Votre livreur est en route!",
  "deliveryStatusOrderTimeout": "Temps de traitement de la commande expiré",
  "deliveryStatusQuoteError": "Erreur lors du traitement de votre commande",
  "deliveryStatusQuoteRequested": "On est en train de traiter votre commande",
  "deliveryStatusQuoteSuccessful": "Nous avons reçu votre commande",
  "deliveryStatusQuoteUnavailable": "On ne peut pas traiter votre commande",
  "deliveryTerms": "Des modalités et des frais s’appliquent à la livraison.\n{link}.",
  "deliveryTerms.ca.heading": "Frais de livraison au Canada :",
  "deliveryTerms.ca.mobileTitle": "Conditions générales de commande et de paiement mobile",
  "deliveryTerms.caFeeValue": "3,00 $",
  "deliveryTerms.californiaHeading": "Californie :",
  "deliveryTerms.coloradoHeading": "Colorado:",
  "deliveryTerms.fee.ca.gte12.label": "Livraison sur les commandes ≥12$ :",
  "deliveryTerms.fee.ca.gte12.value": "Frais de livraison de 2,99 $ + Frais de service de 10 %",
  "deliveryTerms.fee.ca.lt12.label": "Livraison sur les commandes <12$ :",
  "deliveryTerms.fee.ca.lt12.value": "Frais de livraison de 2,99 $ + Frais de service de 10 % + Frais de petit panier de 1,99 $",
  "deliveryTerms.feeLabel": "Frais de livraison :",
  "deliveryTerms.feeValue": "2,99 $ (0 $ pour les commandes de 25 $ et plus)",
  "deliveryTerms.intro": "Livraison proposée dans les restaurants participants aux États-Unis sur l'application BK et bk.com. Commande minimale de 5 $ requise (avant taxes et frais). Prix plus élevés qu'en restaurant. L'inscription à un compte BK est nécessaire. Livraison assurée par des fournisseurs de livraison tiers, sous réserve de disponibilité et des heures de livraison du restaurant. Les coupons imprimés ne sont pas valables pour les commandes de livraison. Toutes les offres numériques ne sont pas disponibles en livraison. Vérifiez les conditions des offres numériques sur bk.com/offers avant de commander. Les frais sont basés sur le sous-total de la commande.",
  "deliveryTerms.intro.ca.part1": "Livraison offerte dans les restaurants canadiens participants sur l'application BK et burgerking.ca. Livraison assurée par des fournisseurs de livraison tiers, sous réserve de disponibilité et des heures de livraison du restaurant.",
  "deliveryTerms.intro.ca.part2": "Les prix peuvent être plus élevés que dans les restaurants. Frais de commande de livraison : des frais de livraison, des frais de service et des frais pour petits paniers peuvent s'appliquer.",
  "deliveryTerms.intro.ca.part3": "Les coupons imprimés ne sont pas valables pour les commandes à livrer. Certaines offres numériques ne sont pas disponibles pour la livraison. Consultez les conditions des offres numériques sur burgerking.ca/rewards/offers avant de commander.",
  "deliveryTerms.retailFeeLabel": "Frais de livraison au détail du Colorado :",
  "deliveryTerms.retailFeeValue": "Des frais de livraison de 0,29 $ sont exigés par la loi pour les livraisons dans l'État du Colorado",
  "deliveryTerms.serviceFeeLabel": "Frais de service :",
  "deliveryTerms.serviceFeeValue": "15% du sous-total de la commande",
  "deliveryTerms.smallCartLabel": "Frais de petit panier :",
  "deliveryTerms.smallCartValue": "2,50 $ pour les commandes de moins de 10 $",
  "deliveryTerms.statesHeading": "Tous les états (sauf la Californie et le Colorado) :",
  "deliveryTerms.title": "Livraison sur l'application BK et sur bk.com",
  "deliveryTerms.title.ca": "Livraison sur l'application BK et burgerking.ca",
  "deliveryTermsHeading": "Conditions de livraison",
  "deliveryTermsPrefix": "Les conditions et frais de livraison s'appliquent. Les prix peuvent être plus élevés que dans les restaurants.",
  "deliveryTime": "Heure de livraison",
  "deliveryUnavailable": "Livraison | Non Disponible",
  "depositFee": "Frais de consigne",
  "describeIssue": "Décrivez votre problème",
  "describeIssueAndIncludePhoneNumber": "Décrivez votre problème (veuillez inclure votre numéro de téléphone)",
  "describeYourVehicle": "Décrivez votre véhicule",
  "descriptionLengthError": "La longueur de la description doit être entre {min} et {max} caractères.",
  "details": "Détails",
  "deviceSettings": "Paramètres du dispositif",
  "diagnostics": "Diagnostique",
  "dialog": "dialogue",
  "didNotReceiveCodeHeading": "N’a pas reçu un code?",
  "differentDeviceError": "Nous avons remarqué que cet appareil n’est pas celui duquel vous avez demandé ce code. Pour ouvrir une session sur cet appareil, veuillez demander un nouveau code ci-dessous.",
  "differentRegion": "Région inconnue",
  "digitalWalletsAndCreditCards": "Portefeuilles numérique et cartes de crédit",
  "dineIn": "En restaurant",
  "dineInAt": "Dîner à",
  "dineInComingSoon": "En restaurant BIENTÔT DISPONIBLE",
  "dineInHours": "Heures d'ouverture de la salle à manger",
  "dineInOrder": "Commande en restaurant",
  "dineInOrderPlaced": "Commande salle à manger passée",
  "dineInUnavailable": "L'option En restaurant n'est pas disponible pour le moment",
  "directions": "Directives",
  "discard": "Supprimer",
  "discardChanges": "Annuler les modifications.",
  "dismiss": "Supprimer",
  "dismissDeliveryModal": "Retour",
  "distance": "Milles",
  "diversity": "Diversité",
  "doYouHaveACouponAlready": "Disposez-vous déjà d'un coupon ?",
  "done": "Terminé",
  "dontForgetToPickYourOrder": "N'oubliez pas de récupérer votre commande bientôt ! Le restaurant ferme à {time}",
  "dontHaveAPromoCode": "Vous n'avez pas de code promo?",
  "dontHaveAnAccount": "Vous n'avez pas de compte?",
  "downloadApp": "Téléchargez notre appli",
  "downloadOnAppStore": "Télécharger au App Store",
  "downloadOurApp": "Téléchargez notre appli. Entrez votre numéro de cellulaire et nous vous enverrons un lien de téléchargement.",
  "downloadTheApp": "Télécharger l'appli",
  "drawerHeading": "titre du tiroir",
  "driveThru": "Service au volant",
  "driveThruAndCounter": "Service au volant et comptoir avant",
  "driveThruAt": "Service au volant à",
  "driveThruComingSoon": "Au service au volant BIENTÔT DISPONIBLE",
  "driveThruHours": "Heures d'ouverture du service au volant",
  "driveThruMobileOrderPlaced": "Commande mobile passée pour service au volant",
  "driveThruOrder": "Commande pour le service au volant",
  "driveThruOrderPlaced": "Commande passée au service au volant",
  "driveThruPickupInstructions": "Avancez à l'écran des commandes et avisez-nous que vous avez commandé en ligne pour {name}.",
  "driveThruUnavailable": "L'option Au service au volant n'est pas disponible pour le moment",
  "duplicateSupportFormSubmission": "Une fiche a déjà été créée concernant votre problème. Veuillez patienter jusqu'à 48 heures pour recevoir une réponse.",
  "earnPoints": "Obtiens des Couronnes",
  "earned": "Vous avez obtenu",
  "earnedPoints": "Historique des transactions",
  "earnedReward": "Vous vous méritez une récompense",
  "earnedTimsRewardsVisits": "Visites FidéliTimMC accumulées",
  "eatIn": "En restaurant",
  "edit": "Modif.",
  "editAddress": "Modifier l'adresse",
  "editAddressFailed": "Impossible de mettre à jour l'adresse. Veuillez réessayer.",
  "editOrder": "Modifier la commande.",
  "eggs": "œufs",
  "email": "Courriel",
  "emailAddress": "Adresse électronique",
  "emailOrPhoneNumberRequiredError": "Il faut fournir une adresse courriel ou un numéro de téléphone",
  "emailPushPreferencesDescription": "Soyez le premier à découvrir les nouveaux produits au menu et nos offres alléchantes.",
  "emailPushPreferencesTitle": "Mises à jour et offres",
  "emailRequiredError": "L'adresse courriel est un champ obligatoire.",
  "emailVerificationSent": "Courriel envoyé! Veuillez vérifier votre e-mail pour le lien de vérification.",
  "emptyCart": "Vider le panier",
  "emptyCartMessage": "Vous n'avez rien dans votre panier pour le moment!",
  "emptyStateTimCTACopy": "Commencer",
  "emptyStateTimCardCopy": "Numérisez pour payer sera accessible après votre premier achat numérique ou le transfert du solde d'une Carte Timᴹᴰ",
  "emptyStateTimCardHeadline": "Carte Tim",
  "enableLocationServices": "Activez les services de localisation",
  "enablePushNotificationsOnDevice": "Afin de recevoir des notifications de Burger King, vous devez d’abord activer les notifications dans les paramètres de votre appareil.",
  "ends": "se terminant",
  "endsIn": "••••",
  "endsInRedesign": "*",
  "english": "English",
  "enjoyYourOrder": "PROFITEZ BIEN DE VOTRE COMMANDE. À BIENTÔT!",
  "enterACode": "Saisissez un code",
  "enterANameForThisOrder": "Entrez un nom pour cette commande",
  "enterAPromoCode": "Entrez un code promotionnel",
  "enterAddressOrDrag": "Entrez une adresse ou faites glisser la carte pour trouver des restaurants près de vous.",
  "enterCardNumber": "Entrez le numéro de la carte",
  "enterFourDigitPin": "Saisissez le code à 4 chiffres indiqué sur le coupon, BK.com, ou l'appli mobile ici :",
  "enterManually": "Entrer le numéro manuellement",
  "enterReceiptCode": "Entrer le code pour gagner",
  "enterVerificationCode": "Entrez le code de vérification",
  "enterYourDeliveryAddress": "Saisis ton adresse",
  "enterYourLovedOnesDeliveryAddress": "Saisir votre adresse de livraison (ou l'adresse de vos bien-aimés)",
  "error.priceOrderFailure": "Échec sur prix de la commande",
  "error404": "Erreur 404",
  "errorBoundaryBody": "Nous éprouvons un problème. Consultez notre menu et nos offres pendant que nous tentons de le résoudre.",
  "errorBoundaryTitle": "Dommage!",
  "errorCreateOrder": "Une erreur s'est produite durant la création de la commande.",
  "errorCreatingSupportCase": "Une erreur s'est produite lors de la soumission de votre dossier d'assistance. Veuillez réessayer",
  "errorDialogCooldownMessage": "Nous préparons en ce moment une commande similaire pour vous. Êtes-vous certain de vouloir commander de nouveau?",
  "errorDialogCooldownTitle": "Commande en cours",
  "errorDialogFavoriteStoreMessage": "Pour programmer votre restaurant favori, inscrivez-vous ou ouvrez une session dans votre compte.",
  "errorDialogFavoriteStoreTitle": "Ouverture de session requise",
  "errorLoadOffers": "Une erreur s'est produite durant le chargement de la réclamation de l'offre.",
  "errorLoadingUserOrders": "Erreur de chargement des commandes de l'utilisateur",
  "errorProcessingRequest": "Il semble qu'une erreur s'est produite lors du traitement de votre demande.",
  "errorRetrievingFavoriteRestaurants": "Restaurants préférés introuvables",
  "errorRetrievingRecentRestaurants": "Restaurants récents introuvables",
  "errorRetrievingRestaurants": "Impossible de trouver les restaurants",
  "errorSavingApplePass": "Une erreur s'est produite au moment d'enregistrer cette carte dans Apple Wallet.",
  "errorSavingGooglePass": "Une erreur s'est produite au moment d'enregistrer cette carte dans Google Pay.",
  "eta": "Délai de livraison prévu",
  "etaFull": "Délai de livraison prévu",
  "eu-calories": "Énergie",
  "eu-carbohydrates": "Glucides",
  "eu-cholesterol": "Cholestérol",
  "eu-fat": "Acides gras",
  "eu-fiber": "Fibre",
  "eu-proteins": "Protéines",
  "eu-salt": "Sel",
  "eu-saturatedFat": "Dont saturés",
  "eu-sodium": "Sodium",
  "eu-sugar": "Dont sucres",
  "eu-transFat": "Acide gras trans",
  "eu-weight": "Poids",
  "euNutritionValues": "{calories} / {joules}",
  "everythingYouLove": "Tout ce que vous aimez de Tim Hortons - désormais à portée de main!",
  "exceedsBalanceLimit": "Ce montant dépasse votre solde",
  "exceedsRewardsBalance": "Si vous ajoutez cette récompense à votre panier d’achats, vous surpasserez votre solde de Couronnes actuel. Veuillez retirer les Couronnes de votre panier d’achats.",
  "exitDeliveryAddressMessage": "Quitter l'adresse de livraison avec des modifications non enregistrées",
  "expirationDate": "Date d'expiration",
  "expirationDateIsRequired": "La date d'expiration est requise",
  "expire": "exp.",
  "expired": "Expirée",
  "expiredCard": "Carte expirée",
  "expires": "Expire",
  "expiresIn": "Expire dans {expiryDays} {expiryHours}",
  "expiresWithDate": "Expire le {endDateText}",
  "expiring": "qui expirent le",
  "expiringPoints": "Points qui expirent",
  "expiringWithDate": "qui expirent {expiringDate}.",
  "exploreOurMenu": "Explorez Notre Menu",
  "faq": "Foire aux questions",
  "fat": "Gras",
  "favorite": "Favoris",
  "favoriteOrders": "Commandes favorites",
  "favoriteRemoveAllModalBody": "Retirer tous les produits de cette commande supprimera votre favori. Voulez-vous vraiment supprimer cette commande?",
  "favoriteRemoveAllModalHeader": "Attendez! Vous n'avez sélectionné aucun produit!",
  "featured": "En vedette",
  "february": "Février",
  "fees": "Frais",
  "feet": "pieds",
  "fetchCoordinatesError": "Nous n'avons pas pu trouver les coordonnées pour l'adresse sélectionnée. Veuillez réessayer.",
  "fiber": "Fibre",
  "fifteenMin": "15 min",
  "filter": "filtre",
  "filterByMonth": "Filtrer par mois",
  "filters": "filtres",
  "findARestaurant": "Trouver un restaurant",
  "findATims": "Trouver un Tim Hortons",
  "findRestaurants": "Trouver des Restaurants",
  "finish": "Terminer",
  "finishOrder": "Terminer la commande",
  "finishYourProfile": "Complétez votre profil",
  "firstName": "Prénom",
  "fish": "poisson",
  "fiveMin": "5 min",
  "foo": "foie",
  "foodQuality": "Qualité des aliments",
  "forItemAvailability": "Disponibilité",
  "forterSignUpError": "Il semble que vous détenez déjà un compte avec nous. Veuillez accéder à votre compte existant ou communiquez avec notre Service de soutien pour obtenir de l’aide.",
  "forwardButton": "Bouton Suivant",
  "foundation": "Fondation",
  "franchising": "Franchisage",
  "free": "Gratuit",
  "freeCoffeeTeOrBakedGood": "Obtenez GRATUITEMENT un café, un thé ou une pâtisserie.",
  "freeDeliveryOnAllOrders": "Livraison gratuite pour toutes les commandes",
  "freeDeliveryOverAmount": "Livraison gratuite pour les commandes de plus de {amount}",
  "french": "Français",
  "frequencyChallengedCompleted": "Défi complété",
  "friday": "Vendredi",
  "from": "De",
  "fromStoreAddress": "de {storeAddress}",
  "fullMenu": "Menu complet",
  "fundingSource": "Source des fonds",
  "futureDateOfBirthProvided": "La date de naissance ne peut pas être ultérieure à la date d'aujourd'hui.",
  "getDirections": "Obtenir l'itinéraire",
  "getOnGooglePlay": "Téléchargez sur Google Play",
  "getRewards": "Obtenez les récompenses",
  "gift": "Cadeau",
  "giftCard": "Carte Cadeau",
  "giftCardAddingError": "Il se peut que les données de la carte cadeau soient inexactes ou qu'il y ait un problème avec votre carte, veuillez réessayer plus tard ou contacter l'émetteur.",
  "giftCardExists": "La carte cadeau existe déjà dans les méthodes de paiement. Vous ne pouvez avoir qu'une seule carte cadeau dans vos méthodes de paiement.",
  "giftCardImageAltText": "Carte-cadeau",
  "giftCardNumber": "Numéro de la carte Crown",
  "giftCardNumberIsNotValid": "Le numéro de la carte cadeau n'est pas valide",
  "giftCardNumberIsRequired": "Le numéro de la carte cadeau est requis",
  "giftSent": "Votre cadeau est en route!",
  "giftSentError": "Malheureusement, nous n’avons pas pu envoyer votre cadeau {gift} à {email}. Veuillez réessayer plus tard ou communiquez avec {supportLink}.",
  "giftSentSuccess": "Vous avez envoyé un cadeau {gift} à {email}.",
  "gluten": "gluten",
  "goToPaymentMethods": "Modes de paiement",
  "goToScanPage": "Numérisez",
  "googlePay": "Google Pay",
  "googlePlay": "Google Play",
  "grabYourReward": "Réclamez votre récompense !",
  "hamburgerMenuAriaLabel": "Naviguer vers le menu Compte",
  "haveItYourWay": "Toujours à ton goût",
  "haveNotReceivedAuthCode": "N’a pas reçu un code?",
  "haveNotReceivedAuthEmail": "Vous n'avez pas reçu de courriel? Si vous n'avez pas reçu de courriel après 3 minutes, vérifiez dans votre boîte de courrier indésirable, ou cliquez sur ce lien : {link}.",
  "headToRestaurant": "Aller en direction du restaurant",
  "help": "Aide",
  "here": "ici",
  "hiX": "Bonjour {name}",
  "highVolumeMessage": "Le volume des commandes que nous recevons à présent est plus grand que prévu. Nous nous excusons pour les délais d'attente et faisons de notre mieux pour vous servir dès que possible. Merci de votre compréhension.",
  "higherPricesWarning": "Prix en hausse possible",
  "history": "historique",
  "historyTab": "Historique",
  "historyTitle": "Historique",
  "hockey1": "Hockey – 1 Choix",
  "hockey2": "Hockey – 2 Choix",
  "hockey3": "Hockey – 3 Choix",
  "home": "Accueil",
  "homeMainFabSignInUp": "Connectez-vous / Inscrivez-vous",
  "homepage": "Page D'accueil",
  "hours": "Heures",
  "hoursAndInfo": "Heures & Info",
  "hoursOfOperationFallbackMessage": "Fermé",
  "howItWorks": "Comment ça fonctionne",
  "howToRedeem": "Comment réclamer l'offre",
  "howToUseTimCard": "Utilisez votre Carte Tim pour payer vos produits. Vous pouvez réapprovisionner votre Carte Tim à tout moment dans votre profil.",
  "howWouldYouLikeToReceiveThisOrder": "Comment souhaitez-vous recevoir cette commande?",
  "howWouldYouLikeToRedeemYourTimCardToday": "Comment voulez-vous utiliser votre Carte Tim aujourd’hui?",
  "ifYouArePayingInRestaurant": "si vous payez en restaurant",
  "imClose": "Je suis à proximité",
  "imCraving": "J’ai une fringale de",
  "imHere": "Je suis ici",
  "image": "image",
  "inRestaurantOrder": "Commande en restaurant",
  "inWithLove": "avec amour au",
  "incentiveFeedbackCartRequirement": "Ajoutez les produits requis à votre panier d’achats afin d’effectuer une réclamation.",
  "incentiveFeedbackCartRequirementExclusion": "Ne peut être jumelée à :",
  "incentiveFeedbackDefault": "Votre panier d’achats ne répond pas aux exigences permettant de réclamer cette {incentiveType}.",
  "incentiveFeedbackExpired": "Cette offre prend fin le {endDate}.",
  "incentiveFeedbackInvalidDay": "Cette offre n’est valide que le {targetValue}.",
  "incentiveFeedbackInvalidStore": "Cette {incentiveType} n’est pas valide au restaurant que vous avez sélectionné.",
  "incentiveFeedbackInvalidTime": "Cette {incentiveType} n’est valide qu’entre {startTime} et {endTime}. Revenez à {startTime} pour profiter de l’offre!",
  "incentiveFeedbackMaxRedemptions": "Vous avez surpassé votre nombre de réclamations permis pour cette {incentiveType}.",
  "incentiveFeedbackNotAvailableInStore": "Non disponible dans ce restaurant",
  "incentiveFeedbackOfferNotAvailable": "Désolés, mais cette offre n’est plus disponible.",
  "incentiveFeedbackOutOfDayPart": "Non disponible en ce moment. Veuillez revenir plus tard!",
  "incentiveFeedbackOutOfDayPartTime": "Disponible dès {time}",
  "incentiveFeedbackPaymentMethod": "Vous devez payer avec {targetValue} afin de réclamer cette {incentiveType}.",
  "incentiveFeedbackServiceMode": "Cette {incentiveType} n’est disponible que pour les {targetValue}.",
  "incentiveFeedbackSubtotal": "Votre total partiel doit s’élever à {targetValue} $ pour réclamer cette {incentiveType}. Ajoutez {calculatedValue} $ pour la réclamer.",
  "incentiveFeedbackWithinCooldown": "Vous avez récemment utilisé cette offre. Vous pourrez en utiliser une autre {calculatedValue} minutes.",
  "incidentInvolvingYourSafety": "Un problème concernant votre sécurité.",
  "included": "Inclus",
  "incrementRollText": "{rollsToShare} REBORD{rollsToShare, plural, =0 {} one {} other {S}}",
  "info": "Info",
  "information": "Information",
  "initializationNetworkRedirectNote": "<Bold>Veuillez noter:</Bold> Tout changement au niveau de récompenses et aux points pourrait ne pas être sauvegardé.",
  "initializationNetworkRedirectOffline": "Réseau non disponible. <Bold>Vous ne recevrez des points que lorsque vous numérisez.</Bold>",
  "instructions": "Instructions",
  "instructionsPlaceholder": "Indiquez au livreur où il doit déposer la commande",
  "instructionsTooLong": "Les instructions doivent comporter moins de 200 caractères.",
  "insufficientBalanceReloadAgain": "Solde prépayé insuffisant – veuillez réapprovisionner votre carte pour passer au paiement.",
  "internalError": "Erreur interne",
  "international": "International",
  "invalidCardNumber": "Numéro de carte invalide",
  "invalidCode": "Code non valide !",
  "invalidDateMissingFields": "Date non valide: {count, plural, one {Le champ} other {Les champs}} {missingFields} {count, plural, one {est requis} other {sont requis}}",
  "invalidDateOfBirthProvided": "La date de naissance fournie n'est pas valide",
  "invalidEmail": "Courriel Non Valide",
  "invalidEmailProvided": "E-mail non valide fourni",
  "invalidInstructions": "Les instructions contiennent des caractères non pris en charge.",
  "invalidLink": "Lien non valide",
  "invalidOfferError": "Votre offre n’est pas valide.",
  "invalidOtpProvided": "Le code que vous avez entré ne correspond pas à celui que nous vous avons envoyé. Veuillez vérifier vos messages et réessayer.",
  "invalidPaymentCardTypeWithOffer": "Le mode de paiement que vous avez sélectionné ne peut pas être appliqué à votre offre actuelle. Mettez à jour votre mode de paiement pour continuer.",
  "invalidPaymentMethodError": "Votre mode de paiement n’est pas valide. Veuillez essayer un autre mode de paiement.",
  "invalidPhoneNumberFormat": "Format de numéro de téléphone invalide. Veuillez saisir un numéro valide.",
  "invalidReloadError": "Nous n’avons pas pu réapprovisionner votre carte.",
  "invalidTipAmountError": "Veuillez soumettre un montant de pourboire valide.",
  "invalidVerification": "Vérification non valide. Entrez le code à nouveau ci-dessous :",
  "inventory": "Inventaire",
  "investorRelations": "Relations avec les investisseurs",
  "investors": "Investisseurs",
  "issueWithMyItems": "Un problème avec mon/mes article(s)",
  "issuesDuringExperience": "Si vous avez eu des problèmes durant le processus de commande,",
  "item": "Produit",
  "itemAddedToCart": "1 {itemName} a été ajouté(e) à votre panier.",
  "itemFavorited": "Élément sauvegardé dans les favoris!",
  "itemFavoritedError": "Oups! Une erreur s’est produite avec votre favori. Veuillez réessayer plus tard.",
  "itemFavoritedRemove": "Élément retiré des favoris.",
  "itemNotAvailable": "Produit non disponible",
  "itemTotal": "Produit Total",
  "items": "Produits",
  "itemsInThisOrder": "Produits dans cette commande",
  "itemsNeverArrived": "Un ou plusieurs produits ne sont jamais arrivés",
  "itemsUnavailable": "Produits non disponibles",
  "itemsWithNutrients": "Je veux des produits avec",
  "itsUsNotYou": "Ce n'est pas vous, c'est nous…",
  "january": "Janvier",
  "joinNow": "Inscris-toi",
  "july": "Julliet",
  "june": "Juin",
  "justMoreToReachNextLevel": "Juste {points} de plus pour atteindre le niveau suivant",
  "keepAddress": "Conserver l'adresse",
  "keepCurrentLocation": "Sauvegarder le choix de restaurant",
  "keepPurchasingItemsToEarnRewards": "Continuer d’acheter des produits pour obtenir des récompenses et les échanger",
  "keepPurchasngItemsToEarnRewards": "Continuez à acheter des articles pour gagner des récompenses et en profiter.",
  "kilometers": "km",
  "languageAndRegion": "Langue et Région",
  "languageAndRegionSelector": "Sélection de la langue et de la région",
  "learnMore": "En savoir plus",
  "leaveNow": "Quitter maintenant",
  "leaveWithoutSaving": "Quitter sans sauvegarder",
  "left": "Reste",
  "legacyImportWelcomeMessageHeader": "Bonjour! Welcome! ",
  "legacyImportWelcomeMessageText": "Nous avons mis à jour notre appli. Veuillez suivre le lien ci-dessous pour ouvrir une nouvelle session",
  "legal": "Légal",
  "legalNotice": "Mention Légale",
  "lessOptions": "Moins d’options",
  "letTheCashierKnowYouPlacedAKioskOrderFor": "Aviser le caissier que vous avez passé une commande pour",
  "letUsKnowYouOrderedForX": "Présentez-vous au service au volant et dites-nous que vous avez passé une commande en ligne au nom de {name}.",
  "letsEat": "On vous sert?",
  "letsGetStarted": "C’est parti, {userName} !",
  "letsLoadX": "Commençons par verser {amount} sur votre carte pour débuter.",
  "limitReached": "Limite atteinte",
  "linkMyCard": "Associer ma carte",
  "linkOpensInNewTab": "Le lien s'ouvre dans un nouvel onglet",
  "linkYourCardDescription": "Associez votre carte pour voir vos points. Entrez votre numéro FidéliTim au dos de votre carte pour le lier à votre compte.",
  "list": "Liste",
  "listOfWordsLayout": "{position, select, first {} last { et } other {, }}{word}",
  "listOfWordsLayoutOr": "{position, select, first {} last { ou } other {, }}{word}",
  "listbox": "zone de listes",
  "loadCard": "Approvisionner la carte",
  "loadLoyaltyError": "Une erreur s'est produite lors du chargement de votre carte FidéliTimMC",
  "loadMore": "Charger plus",
  "loadNow": "Approvisionner maintenant",
  "loadTimCard": "Approvisionner la Carte Tim",
  "loadWith": "Approvisionner avec",
  "loadXOnTimCard": "Verser {amount} sur la Carte Tim",
  "loadYourTimCard": "Approvisionnez votre Carte Tim",
  "loadingMenu": "Menu en cours de chargement",
  "loadingYourExperience": "Chargement de votre expérience personnalisée",
  "loadingYourOrder": "Chargement de votre commande",
  "localeDateTime": "fr-CA",
  "location": "Emplacement",
  "locationClosed": "Restaurant fermé. Les commandes mobiles ne sont pas disponibles pour le moment.",
  "locationDisclaimer": "Nous utilisons votre emplacement pour vous aider à trouver un restaurant tout près et vous offrir de la publicité et des offres plus pertinentes. ",
  "locations": "Emplacements",
  "locatorChangeRegionDisclaimer": "S'il vous plait sélectionner à nouveau votre restaurant. La modification des régions peut affecter la disponibilité des produits.",
  "locatorChangeRegionHeading": "La sélection de cet emplacement changera votre région",
  "locatorChangeRegionPrimaryText": "Vous avez {userRegion} comme région, alors que ce restaurant est dans {restaurantRegion} .",
  "locatorChangeRegionSelection": "Sélectionner une nouvelle région pour continuer.",
  "lockedOfferExpires": "Expire dans {days} jours, {hours} heures",
  "lockedOfferImage": "Image d'offre bloquée",
  "logIn": "Connexion",
  "logInDisclaimer": "Vous n'êtes pas sur votre ordinateur? Assurez-vous de fermer votre session avant de quitter.",
  "logInToRedeem": "Connectez-vous pour obtenir des récompenses",
  "logInToRedeemOnline": "Ouvrez une session pour échanger en ligne",
  "logInWithApple": "Continuer avec Apple",
  "logInWithExistingEmail": "Un compte est déjà associé à cette adresse courriel. Aimeriez-vous plutôt ouvrir une session?",
  "logInWithGoogle": "Continuer avec Google",
  "logOut": "Quitter",
  "logo": "Logo de BK",
  "looksLikeThereWasAnIssue": "Une erreur semble s’être produite durant le traitement de votre demande",
  "looksLikeWereExperiencingIssues": "Il semble qu’un problème s’est produit. Veuillez réessayer!",
  "lostCardDescription": "Si votre carte FidéliTim est perdue ou volée, vous pouvez la désactiver et la supprimer de votre compte. Ne vous inquiétez pas, vos transactions et vos récompenses seront sauvegardées sur votre compte.",
  "lostNetworkConnectivity": "Il semble que vous ayez perdu votre connexion réseau",
  "lostTimCard": "Vous avez perdu votre carte FidéliTim ?",
  "lostYourTims": "Carte FidéliTim perdue",
  "loyaltyCardAlreadyLinked": "Votre carte est déjà associée à ce compte!",
  "loyaltyCardImage": "Image de la carte FidéliTim",
  "loyaltyCardMergeFailed": "Nous sommes désolés, mais nous ne parvenons pas à associer votre carte pour le moment. Veuillez vous assurer que votre carte n'est pas déjà associée à un autre compte. Si elle ne l'est pas, veuillez vérifier votre connexion et essayer à nouveau.",
  "loyaltyCardValidationError": "Cela ne semble pas être un numéro de carte valide. Veuillez entrer un numéro de carte qui ressemble à ABCD-1234-EFGH.",
  "loyaltyCreateAccountHeadline": "Créez un compte pour commencer à",
  "loyaltyDetailsHeroImage": "Obtenez plus de vos choses préférées gratuitement",
  "loyaltyDropdownPoints": "{points} Couronnes",
  "loyaltyHeaderDescription": "Bienvenue au nouveau FidéliTimMC",
  "loyaltyHeaderGreeting": "Bonjour {firstName},",
  "loyaltyHeaderPointsMessage": "Vous avez {points} Couronnes",
  "loyaltyHelp": "Mon niveau de récompenses",
  "loyaltyHistorySignUp": "Inscrivez-vous ou connectez-vous afin de réclamer et d’obtenir vos récompenses et d’accéder à l’historique de vos Couronnes",
  "loyaltyInfoImage": "Image de l'info sur la carte FidéliTim",
  "loyaltyOfflineNoticeBlock": "Vous ne <Bold>recevrez des points</Bold> que lorsque vous numérisez. Tout changement au niveau de récompenses et aux points pourrait ne pas être sauvegardé.",
  "loyaltyOnboardingAutoRedeemPointsFor": "Votre niveau de récompenses est défini à :",
  "loyaltyOnboardingReceivePointsForEligiblePurchases": "Sauvegardez-les jusqu’à ce que vous soyez prêt à les réclamer. Vous pouvez changer votre niveau de récompenses en tout temps.",
  "loyaltyPoints": "Vous avez {points} Couronnes",
  "loyaltyRewards": "Récompenses Fidélité",
  "loyaltyTimCardOfflineNoticeBlock": "Revenez lorsque vous êtes en ligne pour accéder à votre Carte Tim.",
  "loyaltyUnavailableInRegionOops": "Oups!",
  "lunch": "Dîner",
  "lupin": "lupin",
  "made": "Préparé",
  "main": "accueil",
  "mainMenu": "Menu",
  "maintainYourPoints": "Assurez-vous de faire un achat afin de maintenir votre solde de couronnes actif.",
  "makeATrueDifference": "Posez un geste qui compte vraiment",
  "makeAdditionalSelections": "Veuillez faire {quantity} sélection{quantity, plural, one {} other {s}} dans la section « {name} » pour ajouter ce produit à votre panier.",
  "makeThisChange": "Effectuer ce changement?",
  "map": "Carte",
  "march": "Mars",
  "maxAttemptsReached": "Vous avez atteint le nombre maximal de tentatives de connexion permises.",
  "maxAttemptsReachedRequestNewCode": "Vous avez atteint la limite de tentatives d’ouverture de session; veuillez demander un nouveau code ci-dessous.",
  "maximumPriceError": "La valeur de votre panier dépasse la somme maximale pour une commande mobile.",
  "may": "Mai",
  "mayBeCookedOnSameEquipmentAs": "Pourrait avoir été préparé avec le même équipement que cet ou ces ingrédients : {allergens}",
  "mayContainAllergens": "Peut contenir: {allergens}",
  "mayContainAllergensDisclaimer": "Pourrait contenir cet ou ces ingrédients : {allergens}",
  "mayContainAllergensViaSharedEquipment": "Peut contenir via un équipement partagé: {allergens}",
  "media": "Médias",
  "menu": "Menu",
  "menuAcceleratorCartMessage": "Délicieusement récompensé — {points} Couronnes à l’horizon!",
  "menuAcceleratorReviewOrderMessage": "Bon choix! Tu obtiendras {points} Couronnes pour cette commande.",
  "menuCategoryLinks": "liens-catégories-menu",
  "menuModifierAddOption": "Ajouter {modifierName}",
  "menuModifierRemoveOption": "Supprimer {modifierName}",
  "menuTileUnavailableBody": "Aucun article n'est disponible en ce moment. Veuillez vérifier à nouveau plus tard.",
  "menuTileUnavailableButtonText": "Retour au Menu",
  "menuTileUnavailableHeading": "Désolé aucun article trouvé.",
  "message": "Message",
  "messageAllowLocation": "Veuillez autoriser la communication de votre emplacement dans les paramètres",
  "meters": "m",
  "method": "Mode: {serviceMode}",
  "migration30": "Nouvelle FidéliTim!",
  "miles": "milles",
  "milk": "lait",
  "min": "reste",
  "minOrderMessage": "Pour profiter de l'offre, le sous-total de votre panier peut ne pas suffire à couvrir l'offre appliquée.",
  "minimumPointsRequired": "Points minimums requis 50",
  "minimumPriceError": "La valeur de votre panier est inférieure au total requis pour la commande.",
  "minutes": "minutes",
  "missingItems": "Attendez! Il vous manque des produits.",
  "mobile": "Cellulaire",
  "mobileOrder": "Commande mobile",
  "mobileOrderDriveThruOrder": "Commande mobile au service au volant",
  "mobileOrderLane": "Commande mobile au service au volant\n",
  "mobileOrdering": "Commandes mobiles",
  "mobileOrderingAndPaymentTerms": "Modalites des Commandes et Paiements Mobiles",
  "mobileOrderingAndPickup": "Commande mobile et cueillette",
  "mobileOrderingComingSoon": "Les commandes mobiles seront bientôt disponibles!",
  "mobileOrderingUnavailable": "La commande mobile n'est pas disponible",
  "mobileOrderingUnavailableAtStore": "La commande mobile n'est pas disponible pour ce restaurant",
  "mobilePickupVehicleDescription": "Aide-nous à te trouver rapidement en identifiant ton véhicule",
  "mobilePickupVehicleDescriptionPlaceholder": "Couleur et marque de ton véhicule",
  "mobilePickupVehicleTitle": "Description du véhicule",
  "modTakeoutInstructionsText": "Annoncez-nous votre arrivée et nous vous apporterons votre commande. Sinon, nous préparerons votre commande à {time}",
  "modTakeoutInstructionsTextHere": "Nous avons commencé à préparer votre commande. Nous vous l'apporterons dès qu'elle sera prête.",
  "modalHeading": "titre du contenu modal",
  "mode": "Mode",
  "monday": "Lundi",
  "month": "Mois",
  "monthPlaceholder": "MM",
  "monthYearShort": "MM/AA",
  "more": "Plus",
  "moreInfo": "Autres renseignements",
  "moreItems": "{remainingItems, plural, =0 {} other {{remainingItems}}} {remainingItems, plural, =0 {} one {autre produit…} other {autres produits…}}",
  "moreLeft": "il reste plus{linebreak}",
  "moreOptions": "Plus d’options",
  "moreOrdersToGetYouAFreeItem": "plus de commandes pour obtenir un article gratuit!",
  "mustAddPaymentMethod": "Ajouter un mode de paiement",
  "mustBeLoggedInToRedeemCoupon": "Nous sommes désolés. Vous devez être connecté {br} pour réclamer ce bon d’achat.",
  "mustard": "moutarde",
  "myAccount": "Mon compte",
  "myBalance": "Mon Solde",
  "myChallenges": "Mes défis",
  "myGiftCard": "Ma Carte Tim",
  "myOrder": "Ma commande",
  "myRewards": "FidéliTim",
  "myTimCardLink": "Gérer ma Carte Tim",
  "name": "Nom",
  "nameOnCard": "Nom sur la carte",
  "nameOnCardIsRequired": "Vous devez entrer le nom apparaissant sur la carte",
  "nameRequiredError": "Le nom est un champ obligatoire.",
  "nameYourFavorite": "Nommez le favori",
  "nativePaymentNotAvailable": "Nous n’acceptons pas Google Pay ni Apple Pay sur nos sites Web à l’heure actuelle. Veuillez choisir ou ajouter un autre mode de paiement.",
  "navHome": "Accueil",
  "navLinkReorder": "Refaire la commande",
  "navMenu": "Menu",
  "navMyCode": "Mon Code",
  "navOffers": "Offres",
  "navRewards": "Couronnes",
  "nearby": "À proximité",
  "needHelp": "Vous avez besoin d’aide?",
  "needMoreHelpSendUsAMessage": "Encore besoin d'aide ? Envoyez-nous un message",
  "negativeCartError": "Ton panier ne répond pas au prix minimum exigé. Ajoute d’autres produits au panier pour réclamer cette offre et continue.",
  "new": "Nouveau",
  "newCodeSent": "Un nouveau code a été envoyé à votre courriel!",
  "newExclame": "Nouveauté!",
  "newOffer": "Nouvelle offre",
  "newsAndPress": "Actualités et communiqués",
  "next": "Suivant",
  "nextCustomize": "Suivant, Personnalisez",
  "nextPage": "Page suivante",
  "nextReviewYourMeal": "Suivant, vérifie ton repas",
  "nextReviewYourSelection": "Suivant, vérifie ta sélection",
  "nextSelectYourDrink": "Suivant, choisis ta boisson",
  "nextSelectYourSide": "Suivant, choisis ton accompagnement",
  "niceWork": "Bravo, {userName} ! Vous avez gagné",
  "no": "Non",
  "noAppDriving": "N'utilisez pas l'appli en conduisant",
  "noAppDrving": "Veuillez ne pas utiliser l'appli en conduisant",
  "noChangesToOrderTime": "Aucun changement de l'heure de commande ne peut être effectuée à ce stade.",
  "noCourierName": "Nom indisponible",
  "noCourierPhone": "Non disponible",
  "noCurrentRewardsAvailable": "Aucune récompense disponible en ce moment",
  "noDirectPayAndNoPrepaidMethodError": "Nous ne sommes pas en mesure d'accepter votre paiement pour le moment. Veuillez réessayer plus tard.",
  "noFavoritesHeader": "Favoris",
  "noFavoritesSubheader": "Sauvegardez un produit de votre panier ou des récents dans les favoris.",
  "noInternetConnection": "Pas de connexion Internet",
  "noItemsFitCriteria": "Aucun produit ne correspond à vos critères de recherche",
  "noLocationsMatchYourSearch": "Aucun emplacement ne correspond à votre recherche.",
  "noNewOffers": "Aucune nouvelle offre",
  "noOrderYet": "Les commandes seront affichées ici",
  "noOrdersItemsYet": "LES COMMANDES RÉCENTES ET LES PRODUITS SERONT AFFICHÉS ICI",
  "noPaymentMethodOnFile": "Vous n'avez pas de mode de paiement en dossier.",
  "noPaymentMethodSaved": "Vous n'avez pas de mode de paiement enregistré.",
  "noPointExpiry": "Vous n'avez pas encore gagné de points, mais ne vous inquiétez pas, une fois que vous en aurez gagné, vous verrez quand ils expireront.",
  "noRecentItemsHeader": "Aucun élément récent pour le moment",
  "noRecentItemsSubheader": "Passez une commande pour voir vos articles récents ici.",
  "noRestaurantDeliveryCta": "Trouver des Restaurants",
  "noStoresAreOpenForDelivery": "Aucun magasin n’est ouvert pour la livraison.",
  "noThankYou": "Non merci",
  "nonAvailableItemInStore": "Ce produit n’est pas disponible actuellement à votre restaurant sélectionné.",
  "nonAvailableOfferUntil": "Ce bon n'est pas valable avant {time}. Veuillez réessayer plus tard!",
  "nonRedeemableOffer": "Cette offre ne peut pas être échangée",
  "notAvailableAtStore": "Non disponible au restaurant sélectionné",
  "notEnoughPoints": "Vous n’avez pas assez de Couronnes",
  "notValidEmailError": "Cela ne ressemble pas à une adresse courriel valide.",
  "notValidEmailOrPhoneNumberError": "Cela ne semble pas être une adresse courriel ou un numéro de téléphone valide",
  "notValidPhoneNumberError": "Cela ne semble pas être un numéro de téléphone valide.",
  "notValidPhoneNumberPatternError": "Le numéro de téléphone n'est pas dans un format valide, comme : 888-888-8888",
  "notValidRewardsErrorBody": "Le code à barres que vous avez numérisé n’est pas un code à barres FidéliTim. Vous voulez essayer un code à barres différent?",
  "notValidRewardsErrorHeading": "Cela ne ressemble pas à une carte FidéliTim",
  "nothingInCart": "Vous n'avez pas encore de produit dans votre panier",
  "notifications": "Notifications",
  "notifyDescription": "Modifier les types de communications que vous recevez de notre part et comment vous les recevez :",
  "november": "Novembre",
  "now": "Maintenant",
  "numberOfCrowns": "{crowns} Couronnes",
  "nutritionCommitment": "Chez Burger King, nous nous engageons à servir à nos clients de délicieux aliments préparés avec des ingrédients de toute première qualité. Nos sandwichs Whopper emblématiques, faits de bœuf pur à 100 % et servis avec des garnitures fraîchement tranchées, sont un exemple concret de cette promesse. Dans nos restaurants, où tout est toujours préparé au goût de chaque client, nous innovons constamment afin de réaliser de savoureuses recettes incluant des ingrédients qui leur inspirent confiance.",
  "nutritionDisclaimer": "Les renseignements nutritionnels présentés sur ce site Web sont basés sur les formulations de produits standards et ont été obtenus à l'aide des analyses effectuées par notre logiciel nutritionnel, intitulé ESHA Genesis R&D, et des renseignements fournis par nos fournisseurs. Il peut y avoir des écarts en raison des différences entre les fournisseurs, des substitutions d'ingrédients, des changements apportés aux recettes, de la préparation au niveau du restaurant et/ou de la saison de l'année. Il peut y avoir des écarts d'une région à l'autre. Certains produits du menu peuvent varier d’un restaurant à l’autre et peuvent ne pas être disponibles à tous les restaurants. La taille des pâtisseries peut varier. Ces renseignements portent sur une sélection des produits Tim Hortons les plus populaires et peuvent ne pas inclure tous les produits offerts par les restaurants. Les renseignements s'appliquent aux produits offerts par les restaurants au Canada et peuvent être modifiés à tout moment. Veuillez consulter ce site Web régulièrement pour obtenir les renseignements les plus à jour. Les renseignements nutritionnels pour les produits non personnalisés sont conformes aux réglementations gouvernementales en matière d'arrondissement des données nutritionnelles.",
  "nutritionInfoDownloadPDF": "Renseignements nutritionnels",
  "nutritionalInformation": "Renseignements nutritionnels",
  "nutritionalInformationAndAllergen": "Renseignements nutritionnels et sur les allergènes",
  "october": "Octobre",
  "of": "de",
  "offer": "Offre",
  "offerActivationError": "Erreur d'activation de l'offre. Veuillez réessayer.",
  "offerActivationSuccess": "Offre activée",
  "offerAddedToCart": "L’offre a été ajoutée au panier",
  "offerApplied": "Offre appliquée",
  "offerAppliedSuccess": "L’offre a été retirée de votre commande",
  "offerConfirmDialogBody": "Si vous fermez cet écran, le bon sera considéré comme ayant été échangé. Êtes-vous sûr?",
  "offerConfirmDialogConfirmLabel": "Continuer",
  "offerConfirmDialogHeading": "Vous avez terminé?",
  "offerExpires": "Expire le {date}",
  "offerExpiresDays": "Il vous reste {days} jours",
  "offerExpiresHours": "Il vous reste {hours}",
  "offerNotApplied": "Offre non appliquée",
  "offerNotAvailable": "Offre non disponible",
  "offerNotAvailableForMobileRedemption": "Il n’est pas possible de réclamer cette offre en ligne",
  "offerNotAvailableInRestaurantPos": "L’un des produits sélectionnés n’est pas offert à ce restaurant.",
  "offerPicture": "Image de l'offre",
  "offerRedeemableAgainIn": "Vous pouvez réclamer cette offre à nouveau {redeemableIn}",
  "offerRedeemableIn": "Vous pouvez réclamer cette offre {redeemableIn}",
  "offerRedeemableOn": "Vous pouvez réclamer cette offre le {redeemableOn}",
  "offerRequirements": "Les offres dans votre panier ont des conditions qui n'ont pas encore été respectées. Appuyez sur « Réessayer » pour revenir au menu et ajouter les produits requis à votre panier.",
  "offerTerms": "Modalités de l'offre",
  "offers": "Des offres",
  "offersAreCurrentlyNotAvailable": "Vos offres arriveront bientôt.",
  "offersCooldownDescription": "Les offres seront de nouveau disponibles dans {minutes} minutes.",
  "offersCooldownInfo": "Limite d’une offre par visite. Toutes les autres offres seront non disponibles pendant {period} minutes",
  "offersCooldownTitle": "Vous venez de réclamer une offre",
  "offersDisclaimer": "Un(e) par client. Pas de substitutions. N'est pas valable pour des livraisons ou avec d'autres coupons ou offres. Disponible uniquement auprès des établissements qui participent à US Popeyes® (sauf AK & HI). Annuler si interdit ou reproduit ou modifié ou transféré.  Sujet à taxes. Montant liquide de 1/100¢. TM & © 2021 PLKI. Tous droits réservés. Expire le {deactivationDate}",
  "offersEmptyStateText": "Il n'y a aucune offre disponible. Revenez plus tard pour les offres et les mises à jour.",
  "offersNoLocationSelected": "Aucun restaurant sélectionné",
  "offersNoOffersAvailable": "Aucune offre n'est disponible",
  "offersNotAvailableOnDelivery": "Des offres de livraison seront bientôt prêtes pour vous ! Veuillez vérifier bientôt les mises à jour",
  "offersNotAvailableOnDeliveryChangeOrderType": "Modifies ta commande pour le mode « Pickup » pour voir les offres disponibles.",
  "offersNotAvailableOnDeliveryChangeServiceMode": "Votre panier contient une offre qui ne peut être utilisée pour le moment pour les commandes de livraison. Si vous souhaitez passer une commande de livraison, appuyez sur « Continuer » et nous supprimerons cette offre de votre panier.",
  "offersNotAvailableOnDeliveryChangeServiceModeContinue": "Continuer avec la livraison",
  "offersSelectStore": "Sélectionnez un restaurant",
  "offersSelectStoreToViewOffers": "Sélectionnez un restaurant afin de consulter les offres disponibles.",
  "offersYouCanStillEnjoyYourFavorites": "Vous pouvez toujours commander vos produits favoris en commandant du menu.",
  "ok": "Ok",
  "okay": "Ok",
  "okayButtonText": "OK",
  "oneCouponPerOrder": "Limite d'un bon par commande",
  "oneMoment": "Un instant",
  "oneOfferPerOrder": "Une seule offre par commande",
  "onlineSoon": "En ligne bientôt",
  "only": "seulement",
  "oopsComeBackTomorrow": "Oups! Reviens demain à {storeTime} ou sélectionne un autre restaurant.",
  "oopsSomethingWentWrong": "Oups, quelque chose s'est mal passé",
  "open": "Ouvert",
  "open24Hours": "Ouvert 24 heures",
  "openDeviceSettings": "Accédez à vos paramètres",
  "openStoreDiagnosticModal": "Ouvrir un modal diagnostique pour ce restaurant",
  "opportunities": "Occasions",
  "option": "option",
  "optional100PercentGoesToDriver": "optionnel, la totalité est remise au livreur",
  "optionalInformation": "Informations facultatives",
  "or": "ou",
  "orAddNew": "ou Ajouter un(e) autre",
  "orScanForKiosk": "Ou balaie le code au kiosque",
  "order": "Commander",
  "orderAccepted": "Commande acceptée !",
  "orderAtThisStore": "Commandez dans ce magasin",
  "orderCancelled": "Commande annulée",
  "orderCannotBeRefundedMessage": "L’émission de votre remboursement semble avoir échoué. Veuillez signaler le problème en cliquant sur le lien suivant : {link}. Si vous avez déjà demandé un remboursement, la somme apparaîtra dans votre compte d’ici 3 à 5 jours ouvrables.",
  "orderCompleted": "Commande complétée!",
  "orderConfirmation": "Confirmation de la commande",
  "orderConfirmationInstructionsConfirmed": "Nou préparons votre commande et elle sera déposée au comptoir avant dès qu’elle sera prête.",
  "orderConfirmationInstructionsConfirmedCurbside": "Nous avons commencé à préparer votre commande. Stationnez dans un endroit désigné dans le stationnement et nous livrerons votre commande à votre véhicule.",
  "orderConfirmationInstructionsDelivery": "Nous préparons votre commande et elle sera livrée à votre adresse dès qu’elle sera prête.",
  "orderConfirmationInstructionsDriveThru": "Conduisez jusqu’à l’écran des commandes et dites-nous que vous avez commandé en ligne pour {userName}.",
  "orderConfirmationInstructionsMobileDriveThru": "Rendez-vous en voiture à la voie réservée aux commandes mobiles et nous vous apporterons votre commande.",
  "orderConfirmationInstructionsTakeOut": "Nous préparons votre commande et elle sera déposée au comptoir avant dès qu'elle sera prête.",
  "orderConfirmationNumber": "Commande n° {orderNumber}",
  "orderConfirmedHeading": "Commande confirmée!",
  "orderCreated": "Commande créée",
  "orderDate": "Date de la commande",
  "orderDeclined": "Commande refusée!",
  "orderDelivery": "Commande de livraison",
  "orderDeliveryMinimumHeading": "Commande inférieure au montant minimal",
  "orderDetailsHeading": "Détails de la Commande",
  "orderFailureMessage": "Une erreur s'est produite lors de la création de votre commande. Nous sommes au courant du problème et travaillons à le résoudre. Veuillez réessayer ou contacter {link}",
  "orderFailureMessageForApplePay": "Votre paiement effectué avec Apple Pay a échoué. Votre carte ne sera pas débitée et toute transaction en attente est généralement libérée dans les 24 à 48 heures.",
  "orderFailureMessageForGooglePay": "Votre paiement effectué avec Google Pay a échoué. Votre carte ne sera pas débitée et toute transaction en attente est généralement libérée dans les 24 à 48 heures.",
  "orderHasBeenRefundedMessage": "Nous vous avons délivré un remboursement. Vous devriez voir le dépôt dans votre compte d’ici 3 à 5 jours ouvrables.",
  "orderHasBeenSaved": "{userName}, votre commande a été sauvegardée.",
  "orderHere": "Commandez ici",
  "orderHistory": "Historique des Commandes",
  "orderInProgress": "Commande en cours",
  "orderInRestaurant": "Faire une commande dans un restaurant",
  "orderIsBeingMadeYourWay": "{userName}, nous préparons votre commande!",
  "orderLimitHeading": "Limite atteinte pour la commande",
  "orderLimitMessage": "Il semble que votre commande excédera le montant maximal de {maxLimit}. Supprimez un ou deux produits pour ajouter celui-ci à votre commande.",
  "orderLimitWarningX": "La commande ne peut pas dépasser {limit}",
  "orderMinimumMessage": "Le montant de votre commande est inférieur au montant minimal de {minLimit}. Ajoutez d'autres produits pour pouvoir passer votre commande.",
  "orderMinimumWarningX": "La commande doit être de plus de {min}",
  "orderMissingItemscontent": "Veuillez revenir à la page précédente et sélectionner « La commande n’est jamais arrivée » s’il manque la commande au complet.",
  "orderMissingItemsheading": "Problème touchant un ou plusieurs produits",
  "orderMissingItemssubheading": "Confirmez que tous les produits suivants sont manquants",
  "orderName": "Nom de commande",
  "orderNeverArrived": "La commande n’est jamais arrivée",
  "orderNeverArrivedcontent": "Veuillez revenir à la page précédente et sélectionner « Problème touchant un ou plusieurs produits » s’il ne manque qu’une partie de votre commande.",
  "orderNeverArrivedheading": "La commande n’est jamais arrivée",
  "orderNeverArrivedsubheading": "Confirmez que tous les produits suivants sont manquants",
  "orderNotCompleted": "Votre commande n'a pas pu être exécutée",
  "orderNow": "Commandez Maintenant",
  "orderNowWithRewards": "Commander avec des récompenses",
  "orderNumber": "Numéro de commande",
  "orderPayment": "Paiement de la commande",
  "orderPickup": "Commande à ramasser",
  "orderPlaced": "Commande effectuée",
  "orderPlacedAt": "Commande passée au",
  "orderPlacedBy": "Commande passée par ",
  "orderPrepared": "Commande préparée",
  "orderProcessingDisclaimer": "Nous ne commencerons pas à préparer ta commande et ta carte ne sera pas débitée tant que tu n'auras pas appuyé sur «Je suis ici» sur l'écran suivant.",
  "orderProcessingDisclaimerCashPayment": "Nous commencerons seulement à préparer votre commande lorsque vous appuierez sur « Je suis ici » à l’écran suivant.",
  "orderProcessingDisclaimerImClose": "Votre commande ne sera pas préparée et votre carte ne sera pas débitée avant que vous n'appuyiez sur « Je suis à proximité ».",
  "orderProcessingDisclaimerImCloseCashPayment": "Nous commencerons seulement à préparer votre commande lorsque vous appuierez sur « Je suis tout près » à l’écran suivant.",
  "orderRedemptionOrderType": "Réclamation de l’offre : sélectionnez le type de commande",
  "orderTime": "Heure de la commande",
  "orderXWillBeReadyAtY": "La commande {orderNumber} sera prête à {readyAtTime}",
  "orderXWillBeReadySoon": "La commande {orderNumber} sera{linebreak}bientôt prête",
  "orderingFrom": "Commande de",
  "orderingIssues": "Problèmes de commande?",
  "orderingOptions": "Options de commande",
  "ordersMustBePlaced24HrsAhead": "!Les commandes doivent être passées 24 heures à l'avance",
  "ordersMustBePlacedHrsAhead": "!Les commandes doivent être passées {hrs} heures à l'avance",
  "otaDownloadAndRestart": "Téléchargez et redémarrez",
  "otaDownloading": "Téléchargement…",
  "otaUpdateAvailable": "Mise à jour disponible",
  "otaUpdateAvailableDescription": "Une mise à jour importante est disponible. Souhaitez-vous télécharger et appliquer la mise à jour maintenant?",
  "otaUpdateRequired": "Mise à jour requise",
  "otaUpdateRequiredDescription": "Une mise à jour cruciale doit être appliquée pour que cette application continue à fonctionner correctement.",
  "other": "Autre",
  "others": "Autres",
  "otpFormHeadline": "Obtenez des Couronnes à échanger contre des produits au menu",
  "ourMenu": "Notre Menu",
  "ourOffers": "Nos offres",
  "ourRestaurantsNearYou": "Nos restaurants près de vous",
  "outForDelivery": "En cours de livraison",
  "outOfDayparts": "{dayParts} seulement",
  "outOfRangeHeading": "Vous êtes trop loin",
  "outOfRangeMessage": "Malheureusement, nous ne pouvons pas livrer à cette adresse en ce moment. Indiquez votre adresse courriel ci-dessous, et nous vous aviserons lorsque la livraison sera disponible dans votre région.",
  "outdatedCartVersionMessage": "Bonnes nouvelles! Nous avons actualisé notre expérience. Malheureusement, nous avons dû supprimer tout produit antérieurement dans votre panier.",
  "pageMoved": "La page que vous cherchiez a été déplacée ou n'existe pas",
  "pageNotFound": "Page non trouvée",
  "payEarnReward": "Payez, accumulez, réclamez",
  "payWith": "Vous payez comment? ",
  "payWithCash": "Payez en argent comptant",
  "payWithMyPrepaidCard": "Payer Avec Ma Carte {cardAlias}",
  "payWithYour": "Payez avec votre",
  "paymentAddingError": "Les détails de votre carte de crédit sont peut-être erronés ou nous éprouvons des difficultés avec votre carte. Veuillez réessayer ou vérifier auprès de votre banque.",
  "paymentDeclined": "Il nous est impossible de conclure cette transaction. Vérifiez auprès de votre émetteur de carte pour en connaître les raisons.",
  "paymentDeclinedDisclaimer": "Votre commande demeure dans le panier, vous pouvez revenir en arrière pour réessayer",
  "paymentDeclinedHeading": "Oups! Quelque chose n'a pas bien fonctionné et il nous est impossible de compléter cette transaction.",
  "paymentDeletingError": "Une erreur s'est produite lors de la suppression de votre mode de paiement.",
  "paymentDetails": "Détails liés au paiement",
  "paymentDetailsError": "Vérifiez votre carte et essayez à nouveau.",
  "paymentDetailsErrorHeading": "Oups! Les détails de la carte sont incorrects.",
  "paymentFailed": "Votre paiement a échoué",
  "paymentLoadingError": "Une erreur s'est produite lors du chargement de vos mode de paiement.",
  "paymentMethod": "Moyen de Paiement",
  "paymentMethodNotAvailable": "Non disponible",
  "paymentMethods": "Modes de paiement",
  "paymentNotSupported": "Veuillez choisir un autre mode de paiement ou un autre restaurant à proximité.",
  "paymentNotSupportedHeading": "Oups! Le restaurant ne supporte pas votre type de carte.",
  "paymentProcessingError": "Une erreur semble s’être produite durant le traitement de votre paiement. Vous voulez réessayer?",
  "paymentXEndingInY": "Paiement : {cardType} se terminant par {ccLast4}",
  "peanuts": "arachides",
  "people": "Personnes",
  "perOneHundredGOrMl": "Par 100g ou 100ml",
  "perServing": "Par portion",
  "perks": "Couronnes",
  "personalMessageToRecipient": "Message personnel au destinataire.",
  "personalized": "Personnalisé",
  "phoneAppStoresDisclaimers": "Apple et le logo Apple sont des marques de commerce d'Apple Inc., déposées aux États-Unis et dans d'autres pays. L'App Store est une marque de service d’Apple Inc. Google Play est une marque de commerce de Google Inc. Certaines conditions s’appliquent.",
  "phoneNumber": "Numéro de téléphone",
  "phoneNumberDisclaimer": "Le numéro de téléphone enregistré servira aux chauffeurs pour vous rejoindre. En continuant, vous consentez à partager vos coordonnées avec les chauffeurs Door Dash ou Postmates qui livreront vos commandes.",
  "phoneNumberError": "Veuillez entrer un numéro de téléphone valide",
  "phoneNumberPlaceholder": "+13050000000",
  "phoneNumberRequired": "Numéro de téléphone (requis)",
  "phoneNumberRequiredError": "Le numéro de téléphone est un champ obligatoire.",
  "phoneNumberTooLongError": "Le numéro de téléphone indiqué est trop long.",
  "phoneNumberTooShortError": "Le numéro de téléphone indiqué est trop court.",
  "pickALabel": "Ajouter une étiquette (Obligatoire)",
  "pickUp": "Cueillette",
  "pickUpAt": "Pickup à",
  "pickUpAtSelectALocation": "Ramasser à: sélectionnez un lieu",
  "pickUpBefore": "<pickup>Pickup</pickup> avant {pickupTime}",
  "pickUpBeforeDayPart": "<pickup>Cueillir</pickup> avant {dayPartEndTime}",
  "pickUpConfirmationScreenReaderInstructions": "Votre commande a été sauvegardée. Avant d’arriver au restaurant, appuyez sur le bouton \"{screenReaderButtonName}\" pour que nos membres d’équipe préparent votre commande.",
  "pickUpOnly": "Cueillette seulement",
  "pickUpOrder": "Pickup de la commande",
  "pickUpOrderAt": "Heure à laquelle je cueillerai ma commande...",
  "pickUpOrderIn": "Nous commencerons la préparation de votre commande dans...",
  "pickUpOrderPlaced": "Cueillette de la commande",
  "pickUpOrderRestaurantClosing": "Le restaurant n’accepte pas de commande numérique en ce moment",
  "pickUpOrderSuccessfulAlert": "Votre commande a bien été prise en compte, profitez-en. Le numéro de votre commande est {orderNumber} chez {brand} à {address}.",
  "pickUpTime": "Heure de pickup",
  "pickUpUnavailable": "L'option pickup n'est pas disponible pour le moment",
  "pickupComingSoon": "Pickup BIENTÔT DISPONIBLE",
  "pickupDateTime": "{date}{linebreak}{time}",
  "pickupDetailsBackButton": "Retour",
  "pickupDetailsHeading": "Quand cueillerez-vous votre commande?",
  "pickupDetailsNextButton": "Continuer",
  "pickupDetailsSubheading": "Veuillez commander au moins 24 heures à l'avance",
  "pickupModeContentHeading": "Commandez maintenant",
  "pickupModeCurbsideContent": "Passez nous voir et nous vous apporterons votre commande à votre véhicule.",
  "pickupModeCurbsideHeading": "Pickup à l'extérieur",
  "pickupModeDineInContent": "Entrez et consommez votre commande dans le restaurant.",
  "pickupModeDineInHeading": "En restaurant",
  "pickupModeDriveThruContent": "Passez au service au volant et indiquez que vous avez passé une commande mobile.",
  "pickupModeDriveThruHeading": "Service au volant",
  "pickupModeTakeoutContent": "Passez et cueillez votre commande à emporter.",
  "pickupModeTakeoutHeading": "À emporter",
  "pickupNowEta": "Commande prête d’ici 5 à 7 minutes",
  "pickupWindow": "Nous fermons dans {minutes} min. Merci de passer prendre ta commande dès que possible!",
  "pin": "NIP",
  "placeAnOrderToEarn": "Passez une commande pour gagner",
  "placeOrder": "Passer la commande",
  "placeOrderDescription": "Passer une commande de {serviceMode} de {price}",
  "placeSecureOrder": "{secureOrderIcon} Passer la commande",
  "platformOnly": "{platform} seulement",
  "playNow": "Jouer maintenant",
  "pleaseCheckBackNextWeek": "Restez à l'affût pour profiter de nouvelles offres délicieuses.",
  "pleaseConfirmYourCreditCardInformation": "Veuillez confirmer les détails de votre carte de crédit",
  "pleaseEnterYourCreditCardInformation": "Veuillez saisir les informations de votre carte de crédit",
  "pleaseGoToTheFrontCounterToScanRewards": "Veuillez vous rendre au comptoir avant pour scanner les récompenses",
  "pleaseHaveYourCashReady": "Veuillez avoir votre argent en main",
  "pleaseHeadToTheCounterToPayForYourOrder": "Veuillez aller au comptoir pour payer votre commande.",
  "pleaseMakeSelectionInXHours": "Veuillez faire votre choix dans les {hour} heures.",
  "pleaseOrder24InAdvance": "Veuillez commander 24 heures á l'advance",
  "pleasePayForYourOrderUsingTheTerminal": "Veuillez payer pour votre commande sur le lecteur",
  "pleaseReAuthenticateToContinue": "Authentifiez-vous de nouveau pour continuer. Vous serez déconnecté brièvement pour des raisons de sécurité.",
  "pleaseSelect": "Veuillez sélectionner",
  "pleaseSelectAPaymentOption": "Sélectionnez un mode de paiement",
  "pleaseTryAgainLater": "Veuillez réessayer plus tard",
  "pleaseTryToRefresh": "Veuillez essayer d’actualiser.",
  "pleaseVerifyEmail": "Veuillez vérifier votre courriel.",
  "pleaseVerifyYourPhoneNumber": "Veuillez vérifier votre numéro de téléphone",
  "plkLogoTitle": "Popeyes",
  "plkPointsApplied": "Appliqué",
  "points": "Couronnes",
  "pointsApplied": "Couronnes appliquées",
  "pointsEarned": "{pointsEarned, plural, one {Vous avez obtenu {pointsEarned} Couronne!} other {Vous avez obtenu {pointsEarned} Couronnes!}}",
  "pointsEarnedLabel": "Couronne{points, plural, one {} other {s}} obtenues",
  "pointsExpireMonthly": "Les points obtenus il y a plus de 12 mois expireront à la fin de chaque mois.",
  "pointsExpired": "Couronnes expirées",
  "pointsRedeemed": "Couronne{points, plural, one {} other {s}} réclamées",
  "policies": "Politiques",
  "popeyesRewards": "Récompenses Popeyes",
  "postalCode": "Code Postal",
  "postalCodeInvalid": "Code Postal Invalide",
  "postalCodeRequiredError": "Le code postal est un champ obligatoire.",
  "poweredByThirdPartyDeliveryProviders": "Exécuté par des fournisseurs de livraison tiers",
  "preferences": "Préférences",
  "prepaidAccountAlreadyExistsError": "Il est impossible de créer une nouvelle Carte Tim, car votre compte en possède déjà une.",
  "prepareIn10MinLabel": "Commencez à préparer ma commande dans dix minutes",
  "prepareIn15MinLabel": "Commencez à préparer ma commande dans quinze minutes",
  "prepareIn20MinLabel": "Commencez à préparer ma commande dans vingt minutes",
  "prepareIn30MinLabel": "Commencez à préparer ma commande dans trente minutes",
  "prepareIn45MinLabel": "Commencez à préparer ma commande dans quarante cinq minutes",
  "prepareIn5MinLabel": "Commencez à préparer ma commande dans cinq minutes",
  "prepareIn60MinLabel": "Commencez à préparer ma commande dans une heure",
  "prepareNowLabel": "Commencez à préparer ma commande maintenant",
  "preparedOnEquipment": "Préparé avec un équipement utilisé pour produits qui contiennent {preparedOnEquipmentAllergens}.",
  "preparedToOrder": "Préparé sur commande",
  "previousPage": "Page précédente",
  "price": "Prix: {price}",
  "pricedAndAvailableError": "Nous avons rencontré un problème technique temporaire lors du traitement de votre commande. Veuillez réessayer.",
  "pricesDiscountsAndAvailabilityAreSbujectToChangeWhenYouReorder": "Les prix, les rabais et la disponibilité des produits peuvent changer lorsque vous commandez à nouveau.",
  "primaryNavLinks": "Navigation Primaire",
  "privacy": "Confidentialité",
  "privacyPolicy": "Politique de Confidentialité",
  "prizes": "Prix",
  "problemsDetected": "Problèmes détectés",
  "product": "Produit",
  "productChallengedCompleted": "Défi complété",
  "productDetailChooseModifier": "Sélectionnez une option de modification pour {modifierName}",
  "productDetailCloseContent": "Vous souhaitez quitter sans avoir terminé?",
  "productDetailCloseHeading": "Quitter maintenant",
  "productDetailCurrentSelectionX": "Sélection actuelle {selection}",
  "productDetailEditModifier": "Modifier le modificateur",
  "productDetailResetContent": "Le fait de sélectionner une nouvelle option annulera la personnalisation précédemment effectuée.",
  "productDetailResetHeading": "Réinitialiser les modifications",
  "productDetailSummaryCustomizableTitle": "Personnalisez votre commande",
  "productDetailSummaryTitle": "Votre commande",
  "productInformation": "Info sur le produit",
  "profile": "Profil",
  "profileCompletionStarted": "La complétion du profil a commencé !",
  "profileCompletionUpdated": "Complétion du profil mise à jour !",
  "progressbar": "barre de progression",
  "promoCodeApplied": "Le code promotionnel a bien été appliqué! Consultez la section {page} sur la page d’accueil",
  "promoCodeAppliedPage": "Récompenses et offres",
  "promoCodeBodyDetails": "Veuillez entrer le code promotionnel de 12 chiffres ci-dessous",
  "promoCodeCTA": "Vous avez un code promotionnel?",
  "promoCodeLabel": "Entrez le code promotionnel",
  "promoCodeSubmitBtnText": "Soumettre le code",
  "promotionEnded": "La période promotionnelle est terminée",
  "proteins": "Protéines",
  "provideBeforeOrderingAtStore": "Fournis le code avant de commander.",
  "province": "Province",
  "pspPaymentDeclinedMessage": "Bonjour {name}, votre transaction a été refusée. Communiquez avec l’émetteur de votre carte pour obtenir de l’aide.",
  "pspPaymentDeclinedTitle": "Carte refusée",
  "pspPaymentDeclinedTransactionForterMessage": "Bonjour {name}, votre transaction a été refusée. Veuillez utiliser un autre mode de paiement.",
  "pspPaymentDeclinedTransactionForterTitle": "Carte refusée",
  "pspPaymentDeclinedTransactionTitle": "Carte refusée",
  "pspPaymentExpiredCardMessage": "Bonjour {name}, la date d’expiration que vous avez introduite est invalide. Veuillez vérifier la date et réessayez.",
  "pspPaymentExpiredCardTitle": "Carte expirée",
  "pspPaymentIncorrectInformationMessage": "Bonjour {name}, les renseignements liés à la carte que vous avez introduits sont inexacts. Vérifiez l’information et réessayez.",
  "pspPaymentIncorrectInformationTitle": "Renseignements de carte inexacts",
  "pspPaymentInvalidCardMessage": "Bonjour {name}, le numéro de carte que vous avez introduit est invalide. Veuillez vérifier les détails de votre carte et réessayez.",
  "pspPaymentInvalidCardTitle": "Carte invalide",
  "pullToRefresh": "Tirez davantage vers le bas pour rafraîchir",
  "purchaseAdded": "Cet achat a été ajouté à votre nombre de visites",
  "purchaseAmount": "Montant",
  "purchaseDidNotCountTowardsReward": "Cet achat n'a pas été compté pour votre prochaine récompense. Veuillez consulter le {link} pour en savoir plus.",
  "purchaseSevenTimes": "Effectuez 7 achats",
  "push": "Notifications poussées",
  "pushNotifications": "Activez les notifications",
  "putThisCodeUnderTheScanner": "pour gagnez des points et récompenses",
  "pypestreamWelcomeAnon": "Bonjour! Je suis l’assistant numérique {brand} et je suis ici pour vous aider si vous éprouvez des difficultés avec vos commandes et pour répondre à vos questions. Veuillez patienter un petit moment pendant que je consulte votre dossier.",
  "pypestreamWelcomeUser": "Allô {name}! Je suis l’assistant numérique {brand} et je suis ici pour vous aider si vous éprouvez des difficultés avec vos commandes et pour répondre à vos questions. Veuillez patienter un petit moment pendant que je récupère l’historique de vos commandes.",
  "qty": "qté",
  "quantity": "Quantité",
  "quantityItemInYourCart": "{quantity} {itemName} dans votre panier",
  "quantityOf": "Quantité de {name}",
  "quantityUpdatedAlert": "Vous avez maintenant {quantity} {itemName} dans votre panier.",
  "questTerms": "{quest} Conditions",
  "question": "Question",
  "questionsAboutOrder": "Vous avez des questions sur votre commande?",
  "quickNote": "Remarque",
  "readLess": "Voir moins",
  "readMore": "Voir plus",
  "receipt": "Reçu",
  "recent": "Récentes",
  "recentItems": "Produits récents",
  "recentItemsFailed": "Oups! Le chargement des articles récents a échoué",
  "recentOrders": "Commandes récentes",
  "recentOrdersDisclaimer": "Les prix, les rabais et la disponibilité des produits peuvent changer lorsque vous commandez à nouveau.",
  "recentOrdersEmptySubHeader": "Allez passer une nouvelle commande dès maintenant!",
  "recents": "Récents",
  "recipientsEmail": "Email du destinataire",
  "recyclingFee": "Frais de recyclage",
  "redeem": "Réclamez",
  "redeemACoupon": "Échanger un coupon",
  "redeemApply": "Utilisez {points}",
  "redeemInNext": "À réclamer d’ici",
  "redeemInRestaurant": "Réclamer au Restaurant",
  "redeemMyPoints": "Réclamer mes points",
  "redeemNow": "Réclamez maintenant",
  "redeemOfferConfirmation": "Pour profiter de l'offre, le sous-total de votre panier doit être égal ou supérieur à la valeur de l'offre. Si vous choisissez de continuer, nous supprimerons l'offre de la commande.",
  "redeemPointsDisclaimer": "Vos points seront seulement utilisés pour les objets sélectionnés",
  "redeemRemove": "Supprimer {points}",
  "redeemReward": "Réclamez votre récompense",
  "redeemRewards": "Réclamez des récompenses",
  "redeemTab": "Réclamez",
  "redeemThisCoupon": "Réclamer ce bon d’achat",
  "redeemedRewards": "{redeemedRewards, plural, one {Vous avez réclamé {redeemedRewards} récompense.} other {Vous avez réclamé {redeemedRewards} récompenses.}}",
  "redeeming": "Couronnes réclamées",
  "refresh": "Actualiser",
  "refreshOffers": "Actualiser mes offres",
  "refundEligibilityInfo": "Les commandes sont admissibles à un remboursement partiel ou complet. Sélectionnez parmi vos commandes ci-dessous pour soumettre une demande de remboursement.",
  "refundNetworkError": "Une erreur semble s’être produite dans la préparation de votre remboursement. Veuillez {link} pour signaler le problème. Si vous avez déjà demandé un remboursement, veuillez allouer de 3 à 5 jours ouvrables pour voir le dépôt dans votre compte.",
  "register": "S'inscrire",
  "registerCardDescription": "Entrez le NIP au dos de la carte pour protéger votre solde, continuer à recevoir des récompenses et en faire le suivi. Vos transactions et récompenses précédentes seront ajoutées à votre compte.",
  "registerYourPhysicalCard": "Associer ma carte FidéliTim ",
  "regular": "Régulier",
  "releaseToRefresh": "Relâchez pour actualiser!",
  "reload": "Réapprovisionner",
  "reloadAndContinue": "Réapprovisionnez {amount} et continuez",
  "reloadAndPlaceOrder": "Réapprovisionner {amount} et passer la commande",
  "reloadCard": "Réapprovisionner la carte",
  "reloadCardError": "Une erreur s’est produite durant l’approvisionnement de votre Carte Tim.",
  "reloadCardWithAmount": "Réapprovisionner {amount}",
  "reloadExplanation": "Votre solde actuel sur la carte  BK Crown ne couvre pas le coût de la commande d'aujourd'hui. Quand vous faites une commande nous facturons {reloadAmount} sur votre carte Crown.",
  "reloadMethods": "Méthodes de réapprovisionnement",
  "reloadNow": "Réapprovisionner maintenant",
  "reloadYourBalance": "Réapprovisionnez votre solde",
  "reloadYourCard": "Réapprovisionner la carte",
  "rememberToMakeAPaymentDelivery": "N’oubliez pas de payer votre commande lors de la livraison",
  "rememberToMakeAPaymentPickup": "N’oubliez pas de payer votre commande lors de pickup",
  "remove": "Retirer",
  "removeAddressBody": "Êtes-vous sûr de vouloir le supprimer de vos adresses enregistrées ? Cette action ne peut pas être annulée.",
  "removeAddressHeading": "Supprimer cette adresse ?",
  "removeCustomizations": "Cette action annulera toutes les modifications apportées à ce/cette {itemType}.",
  "removeExpiredOfferItem": "Nous avons retiré des produits du panier qui ne sont pas offerts en ce moment.",
  "removeFavorite": "Retirer des favoris?",
  "removeFavoriteConfirm": "Voulez-vous vraiment retirer ce favori?",
  "removeFavoriteOrderSucess": "Commande retirée des favoris.",
  "removeFavoriteSucess": "Votre favori a été retiré.",
  "removeItem": "Retirer un produit",
  "removeItemFavorites": "Retirer cet élément des favoris?",
  "removeItemFavoritesConfirm": "Voulez-vous vraiment retirer ce favori?",
  "removeItemFromCart": "Êtes-vous sûr de vouloir retirer ce produit, {item}, de votre panier?",
  "removeItemFromCartOfferText": "Veuillez noter que la suppression de cet article supprimera également l'offre ci-jointe.",
  "removeItems": "Retirer des produits",
  "removeOne": "Supprimer un",
  "removeOneItemFromCart": "Retirer 1 {item name} du panier",
  "removeOneName": "Supprimer un {name}",
  "removePaymentMethod": "Supprimer le mode de paiement",
  "removeRestaurantFromFavorites": "Retirer ce restaurant des favoris",
  "removeReward": "Retirer la récompense",
  "removeRewardsFromCart": "Retirer récompenses du panier",
  "removeUnavailableEntries": "Retirer les éléments non disponibles?",
  "removeUnavailableItems": "Supprimer les produits non disponibles",
  "reorder": "Commander",
  "replace": "Remplacer",
  "replaceCoupon": "Souhaitez-vous remplacer le bon qui était déjà appliqué à votre panier?",
  "replaceOffer": "Vous souhaitez remplacer l’offre déjà présente dans votre panier ?",
  "reportAnIssue": "Signaler un problème",
  "reportIssue": "Signaler un problème",
  "reportOrderIssuePageTitle": "Signaler un problème avec la commande",
  "requestMyInfo": "Demander mes info",
  "requestMyInformation": "Demander mes informations",
  "requestNewLinkAuthEmail": "demander un nouveau lien",
  "required": "Requis",
  "requiredField": "Il s'agit d'un champ obligatoire",
  "resend": "Envoyer à nouveau",
  "resendCode": "Renvoyer le code",
  "reset": "Réinitialiser",
  "resetCustomizationsDescription": "En sélectionnant cette option, vous supprimerez tout ce que vous avez personnalisé pour votre commande. Voulez-vous continuer?",
  "resetCustomizationsHeader": "Réinitialisez la personnalisation",
  "responsibility": "Responsabilité",
  "restartPurchaseProcessButton": "Sélectionnez un nouveau restaurant",
  "restartPurchaseProcessDisclaimer": "En sélectionnant un nouveau restaurant, vous supprimerez votre panier d’achats et commencerez une nouvelle commande.",
  "restaurantClosed": "Restaurant fermé",
  "restaurantClosedDialogBody": "Pas de souci, tu peux commander d’un autre restaurant à proximité.",
  "restaurantClosedDialogBodyClosestOptionAvailable": "L’option la plus près est :",
  "restaurantClosedDialogBodyDelivery": "Désolés, tous les restaurants qui offrent la livraison sont fermés. Réessaye plus tard ou sélectionne la cueillette.",
  "restaurantClosedDialogButton": "Confirmer nouveau restaurant",
  "restaurantClosedDialogButtonCancel": "Choisir un autre restaurant",
  "restaurantClosedDialogButtonDelivery": "Choisir la cueillette",
  "restaurantClosedDialogHeading": "Restaurant sélectionné fermé",
  "restaurantClosedDialogHeadingDelivery": "Livraison non disponible",
  "restaurantCloses": "Le restaurant ferme dans {minutes} min",
  "restaurantDetails": "Détails du restaurant",
  "restaurantOrder": "Commande restaurant",
  "restaurantOrderComingSoon": "Commande en restaurant à venir sous peu!",
  "restaurantRedemption": "Déjà à un restaurant et prêt à réclamer? {clickHere}",
  "restaurantRedemptionClickHere": "Cliquez ici",
  "restaurantUnavailableErrorMessage": "Le restaurant où vous tentez de commander n'est pas disponible en ce moment.",
  "restaurantUnavailableErrorTitle": "Ce restaurant n’est pas disponible",
  "restaurants": "Restaurants",
  "resultsLeft": "Il reste {count} résultats",
  "retry": "Réesayer",
  "returnToMenu": "Retour au menu",
  "review": "Revoir",
  "reviewYourMeal": "Vérifie ton repas",
  "reviewYourOrder": "Vérifiez votre commande",
  "reviewYourSelection": "Vérifie ta sélection",
  "reward": "Récompense",
  "rewardAfterXPurchases": "Recevez une récompense après {pointsUntil} achats.",
  "rewardApplied": "Récompense réclamée",
  "rewardCategory": " Niveaux de récompense {selectedOptionText}-  {categoryName}",
  "rewardInfo2": "Tous les achats de plus de 0,50 $ effectués à au moins 30 minutes d'intervalle seront admissibles.",
  "rewardInfo3": "Vous pouvez accumuler jusqu'à 5 récompenses à la fois.",
  "rewardInfo4": "Lorsque vous échangez une récompense, l'article admissible le plus dispendieux de votre commande sera GRATUIT.",
  "rewardSavings": "Économies de récompense",
  "rewardUnavailable": "Non valide",
  "rewardUnlocked": "Joli ! Récompense débloquée",
  "rewardXInfo1": "Effectuez {pointsUntil} achats à un restaurant Tim Hortons® participant et obtenez une récompense GRATUITE pour des produits admissibles.",
  "rewards": "Récompenses",
  "rewardsAndOffers": "Récompenses et offres",
  "rewardsHistory": "Historique FidéliTim",
  "rewardsLevelChange": "Votre niveau de récompenses est mis à jour",
  "rewardsMainImage": "L'image principale des récompenses",
  "rewardsManagementChangeRewardLevel": "Modifier le niveau de récompense",
  "rewardsManagementChoosenLevel": "Niveau de récompenses",
  "rewardsManagementPoints": "{points} Points",
  "rewardsPointsBalanceIsNow": "Votre solde de points FidéliTim est de {remainingPoints}.",
  "rewardsPointsDetailsMessage": "Vous avez {points} points",
  "rewardsPointsTitle": "Points de FidéliTim",
  "rewardsPolicy": "Politique de récompenses",
  "rollsAddedToAccountText": "REBORD{numberOfRollsShared, plural, one { a} other {s ont}} été ajouté{numberOfRollsShared, plural, one {} other {s}} à votre compte.",
  "rollsClaimedMessage": "Vous venez de réclamer {numberOfRollsShared, plural, one {un} other {{numberOfRollsShared}}} rebord{numberOfRollsShared, plural, one {} other {s}} à déRRRouler!",
  "roundUpDescription": "Arrondissez vos commandes au 0,10 $ supérieur lorsque vous numérisez votre carte FidéliTim ou commandez à l'avance via l'appli. Vous soutiendrez ainsi les Camps de la Fondation Tim Hortons® et aiderez les jeunes de votre communauté. Cliquez ici pour en avoir plus.  {link}.",
  "roundUpTitle": "Arrondissez le montant de votre commande pour appuyer les Camps Tim Hortons?",
  "routes.accepted": "/accepted",
  "routes.account": "/compte",
  "routes.accountDelete": "/compte/supprimer",
  "routes.accountRequestInfo": "/compte/demander-information",
  "routes.claimPointsBase": "/claim-crowns",
  "routes.claimPointsProcessing": "/claim",
  "routes.claimPointsSurvey": "/survey",
  "routes.deliveryTerms": "/conditions-livraison",
  "routes.exploreMenu": "/nouveaux-gouts",
  "routes.hockey-challenge-en": "/hockey-challenge*",
  "routes.hockey-challenge-fr": "/defi-hockey*",
  "routes.linkPhysicalCard": "/link-card",
  "routes.loyaltyDashboard": "/rewards/details",
  "routes.loyaltyHome": "/rewards",
  "routes.loyaltyOfferList": "/rewards/offers",
  "routes.loyaltyRewardList": "/rewards/list",
  "routes.mobileOrderingAndPaymentTerms": "/modalites-des-commandes-et-paiements-mobiles",
  "routes.pandemonium": "/pandémonium",
  "routes.perksTermsConditions": "/conditions-recompenses",
  "routes.privacyPolicy": "/politique-de-confidentialite",
  "routes.redemptionInRestaurant": "/redeem",
  "routes.reusables": "/reusable",
  "routes.rewards": "/rewards",
  "routes.rewardsHistory": "/rewards/history",
  "routes.rewardsOnboarding": "/recompenses-lintegration",
  "routes.rewardsPolicy": "/politique de récompenses",
  "routes.scan": "numeriser",
  "routes.scanTH": "/numeriser",
  "routes.scanTimRewards": "/numeriser/fidelitim",
  "routes.sendGift": "/cadeau",
  "routes.signIn": "/connectez-vous",
  "routes.signUp": "/inscrivez-vous",
  "routes.storeLocator": "/localisateur-de-magasin",
  "routes.termsConditionsRewards": "/conditions-recompenses",
  "routes.termsOfService": "/conditions-dutilisation",
  "routes.timCard": "/account/tim-card",
  "routes.tims-for-good-en": "/tims-for-good",
  "routes.tims-for-good-fr": "/timdubienauquotidien",
  "routes.timsRewards": "/tims-rewards",
  "routes.timsRewardsTab": "/tims-rewards/:tab",
  "routes.timsRewardsTermsAndConditions": "/fidelitim-modalites-conditions",
  "royalPerks": "Récompenses King",
  "ruleSetsCannotRedeemAgain": "Vous avez atteint la limite des réclamations pour cette offre. {redeemableInString}",
  "ruleSetsCannotRedeemNow": "Vous ne pouvez pas réclamer cette offre aujourd'hui. {redeemableInString}",
  "ruleSetsCartPropertyViolation": "Votre panier ne respecte pas les exigences pour cette offre.",
  "ruleSetsDayOfWeekViolation": "Vous ne pouvez pas réclamer cette offre aujourd'hui. {redeemableInString}",
  "ruleSetsFirstOrderOnlyViolation": "Vous ne pouvez réclamer cette offre que dans votre première commande. ",
  "ruleSetsPurchaseViolation": "Votre panier ne contient pas les produits requis pour réclamer cette offre. ",
  "ruleSetsRequiresAssignmentViolation": "Vous n'êtes pas admissible à cette offre.",
  "safteyIssue": "Problème de sécurité",
  "salt": "Sel",
  "saturatedFat": "Lipides saturés",
  "saturday": "Samedi",
  "save": "Sauvegarder",
  "saveAddressDisclaimer": "Veuillez sauvegarder mon numéro de téléphone et mon adresse de livraison afin de me permettre de régler la facture plus rapidement lors de ma prochaine commande.",
  "saveAddressLabel": "Sauvegarder mes données. {disclaimer}",
  "saveCardDisclaimer": "Enregistrer la carte - En enregistrant votre carte, vous consentez à ce qu'elle soit conservée en dossier et utilisée pour vos achats.",
  "saveCardDisclaimerRedesign": "Enregistrer la carte - En enregistrant votre carte, vous consentez à ce qu'elle soit conservée en dossier et utilisée pour vos achats.",
  "saveChanges": "Enregistrer les modifications",
  "saveFavoriteOrderButton": "Sauvegarder dans les favoris.",
  "saveFavoriteOrderNameError": "Veuillez entrer un nom de commande.",
  "saveFavoriteOrderSucess": "Commande sauvegardée dans les favoris!",
  "saveFavoriteOrderText": "Quel nom voulez-vous donner à cette commande?",
  "saveFavoriteOrderUnsaved": "Vous avez des changements non sauvegardés.",
  "saveFavoriteOrderUnsavedBody": "Voulez-vous continuer sans sauvegarder les modifications apportées dans votre commande favorite?",
  "saveInformationToMyAccount": "Se souvenir de mon numéro de téléphone et de mon adresse pour les futures commandes de livraison.",
  "saveMyPointsForLater": "Sauvegarder mes points pour plus tard",
  "savedAddresses": "Adresses sauvegardées",
  "savedOrder": "Votre commande a été sauvegardée.",
  "savedOrderTapImClose": "Commande enregistrée. Appuyez sur « Je suis à proximité » lorsque vous êtes à 5 minutes. Votre carte ne sera pas débitée d’ici là.",
  "savedOrdertapImHere": "Votre commande a été enregistrée. Appuyez sur « Je suis ici » quand vous arrivez afin que nous puissions préparer votre commande. Votre carte ne sera pas débitée d’ici là.",
  "scan": "Numérisez",
  "scanAndPay": "Numérisez et payez",
  "scanAndPayHasBeenDisabled": "Numérisez & payez est desactivée",
  "scanAndPayPaymentMethodUpdated": "Méthode de paiement est mise à jour",
  "scanBarcode": "Numérisez le code à barres",
  "scanForTimsRewards": "Numérisez votre carte FidéliTim",
  "scanForTimsRewardsBeforePaying": "Numérisez votre carte Fidélitim",
  "scanMoreRewards": "Numérisez pour obtenir d'autres récompenses",
  "scanQRCode": "Numérisez votre code QR si vous payez au restaurant.",
  "scanRewards": "2.\tNumériser FidéliTim",
  "scanRewardsCard": "Numérisez une carte FidéliTim",
  "scanTimCardTerminal": "Scannez votre carte Tim Rewards au terminal",
  "scanToEarnPointsPayAndUseRewards": "payer, gagner des points et utiliser des récompenses",
  "scanToEarnRewardsAndPay": "Numérisez votre carte Fidélitim et payer",
  "scanToPayWithTimCard": "Numérisez pour payer",
  "scanToPayWithYourTimCard": "Numérisez pour payer",
  "scanYourTimCardAtTheTerminal": "Numérisez votre carte sur le lecteur",
  "scanYourTimsCardToGetRewards": "Numérisez votre carte FidéliTim pour obtenir vos récompenses pour cette visite!",
  "school": "École",
  "searchThisArea": "Rechercher ce secteur",
  "seasonalTreats": "Friandises de Saison",
  "seconds": "secondes",
  "seeDeliveryPartners": "Afficher les partenaires de livraison",
  "seeDetails": "Détails",
  "seeMoreOptions": "Plus d’options",
  "select": "Sélectionner",
  "selectACountry": "Sélectionnez un pays",
  "selectAFilter": "Sélectionnez un filtre...",
  "selectBestRewardLevel": "Lorsque vous aurez suffisamment de points, ceux-ci seront automatiquement échangés contre les articles sélectionnés.",
  "selectGift": "Sélectionnez un cadeau",
  "selectGiftError": "Veuillez sélectionner un cadeau.",
  "selectLanguage": "Sélectionner une langue",
  "selectLocation": "Sélectionner le restaurant",
  "selectManually": "Sélectionner manuellement",
  "selectPaymentMethod": "Sélectionner le mode de paiement",
  "selectPaymentMethodDrawer": "Sélectionner le mode de paiement",
  "selectPaymentMethodToAddFunds": "Veuillez sélectionner le mode de paiement qui sera utilisé pour ajouter des fonds sur votre compte.",
  "selectPickup": "Choisir la méthod de collecte",
  "selectQuantity": "Sélectionner la quantité",
  "selectRemaining": "Sélectionnes-en {amount} de plus",
  "selectRestaurant": "Sélectionner le resto",
  "selectRestaurantToViewOffers": "Sélectionnez un restaurant pour voir les offres locales",
  "selectTheCorrectAnswer": "Sélectionnez la bonne réponse",
  "selectThisStore": "Sélectionner ce restaurant",
  "selectUpTo": "Sélectionnez jusqu’à {amount} {itemName}",
  "selectedRestaurant": "Restaurant sélectionné",
  "selectedRewardLevelAndBankMyRewards": "Niveau de récompense sélectionné et déposer mes récompenses",
  "selectingStartOver": "En sélectionnant Recommencer, vous supprimerez votre panier d’achats et commencerez une nouvelle commande.",
  "selectionNotAvailable": "Nous sommes désolés, votre choix n’est pas disponible.",
  "sendAnotherGift": "Envoyer un autre cadeau",
  "sendGift": "Envoyer un cadeau",
  "sendGiftEmailRequiredError": "Veuillez entrer l’adresse courriel du destinataire.",
  "sendGiftNameRequiredError": "Veuillez entrer votre prénom et votre nom de famille.",
  "sendNewCode": "Envoyer un nouveau code",
  "september": "Septembre",
  "serviceFee": "Frais de service",
  "serviceFeeDescription": "Les frais de service représentent {percent}% de votre commande avant taxes.",
  "serviceModeDetailsCurbsideDescription": "Stationnez-vous et nous apporterons votre commande à votre voiture.",
  "serviceModeDetailsCurbsideDescriptionV2": "Dans le stationnement\n",
  "serviceModeDetailsCurbsideHeader": "Pickup à l'extérieur",
  "serviceModeDetailsDineInDescription": "Entrez et assoyez-vous. Nous vous appellerons par votre nom lorsque votre commande sera prête.",
  "serviceModeDetailsDineInDescriptionV2": "Au comptoir\n",
  "serviceModeDetailsDineInHeader": "En Restaurant",
  "serviceModeDetailsDriveThruDescription": "Approchez votre voiture et faites-nous savoir que vous avez passé une commande en ligne.",
  "serviceModeDetailsDriveThruDescriptionForMobileOrder": "Rendez-vous en voiture dans la voie réservée aux commandes mobiles et nous sortirons vous porter votre commande.",
  "serviceModeDetailsDriveThruDescriptionV2": "Dans la voie du service au volant\n",
  "serviceModeDetailsDriveThruHeader": "Service Au Volant",
  "serviceModeDetailsDriveThruHeaderForMobileOrder": "Commande mobile au service au volant\n",
  "serviceModeDetailsPickupDescription": "Votre commande sera prête au comptoir à votre arrivée.",
  "serviceModeDetailsPickupDescriptionV2": "Au comptoir\n",
  "serviceModeDetailsPickupHeader": "À Emporter",
  "serviceModeDetailsUnavailable": "Indisponible",
  "serviceModePrompt": "Comment voulez-vous recevoir votre commande?",
  "serviceModePromptAlternative": "De quel type de commande s'agit-il?",
  "serviceModeSelectorTitle": "Choisis ton mode de ramassage",
  "serviceVisit": "Couronnes compensatoires",
  "sesame": "sésame",
  "setPickup": "Programmez votre mode de cuillette",
  "setRestaurantAsFavorite": "Régler ce restaurant en tant que favori",
  "setRewardsTierError": "Nous sommes désolés, mais nous n'avons pas réussi à fixer votre niveau de récompenses. Veuillez vérifier votre connexion et réessayer.",
  "shakes": "Laits fouettés",
  "share": "Partager",
  "shareMyLocation": "Partager ma position",
  "shareRollsPageButtonText": "Partagez {rollsToShare} REBORD{rollsToShare, plural, =0 {} one {} other {S}}",
  "shareRollsPageRollToText": "REBORD{rollsRemaining, plural, =0 {} one {} other {S}} à",
  "shareYourLocation": "Partagez votre position",
  "shareYourRoll": "Partagez vos rebords et Déroulez pour gagner🅪!",
  "sharedLandingButtonText": "Dérrroulez",
  "shellfish": "mollusques et crustacés",
  "shoppingCartPreview": "Aperçu du panier",
  "showDetails": "Afficher les détails",
  "showLess": "Afficher moins",
  "showMeDeals": "Montrez-moi des offres",
  "showMore": "Afficher plus",
  "signIn": "Connexion",
  "signInCodeSentToEmailAgain": "Votre code de connexion a été envoyé à votre adresse courriel! Veuillez vérifier votre dossier de courriels indésirables",
  "signInIfYouAlreadyHaveAccount": "Connectez-vous si vous avez déjà un compte",
  "signInOrCreateAccount": "Ouvrez une session ou créez un compte",
  "signInSuccess": "Vous avez ouvert une session avec succès!",
  "signInToViewOrders": "Connectez-vous pour Voir les commandes.",
  "signInUp": "Inscription/Connexion",
  "signOut": "Déconnexion",
  "signOutConfirmSubheader": "Voulez-vous vraiment vous déconnecter?",
  "signUp": "Inscris-toi",
  "signUpError": "Une erreur s'est produite lors de l'inscription",
  "signUpForBkRewards": "Inscrivez-vous aux BK Rewards",
  "signUpForPromotionalEmails": "Inscrivez-vous pour recevoir des courriels promotionnels",
  "signUpNow": "Inscrivez-vous maintenant",
  "signUpNowToGetStartedWith": "Inscrivez-vous dès aujourd’hui et commencer à accumuler des {rewardsLink}",
  "signUpOrSignIn": "Inscrivez-vous ou connectez-vous",
  "signUpSuccessSignInFail": "Votre compte a été créé. Veuillez ouvrir une session pour continuer.",
  "signUpToContinue": "Inscrivez-vous pour continuer",
  "signUpToContinueDisclaimer": "Les taxes et les frais seront calculés à l’étape finale. Connectez-vous ou inscrivez-vous pour vérifier et passer votre commande.",
  "signUpToGetStartedWith": "Inscrivez-vous pour profiter des avantages {rewardsLink}",
  "signUpToRedeem": "Inscrivez-vous pour obtenir des offres",
  "signinToRedeem": "Ouvrez une session pour réclamer votre récompense",
  "signupEmailSent": "Nous venons d'envoyer un courriel à {email}. Entrez le code de vérification ci-dessous",
  "singleUseCupFee": "Frais tasse jetable",
  "sitemap": "Plan du site",
  "skip": "Passer",
  "skipTheLinePart1": "Sautez",
  "skipTheLinePart2": "la",
  "skipTheLinePart3": "file",
  "skipToContent": "Passer au contenu",
  "slowNetworkIssue": "Nous traitons toujours votre demande. Cela peut prendre un peu plus de temps que d'habitude.",
  "smallCartFee": "Frais pour petit panier",
  "smallCartFeeDescription": "Ces frais ne s'appliquent qu'aux commandes de moins de {amount}. Ajoutez des articles pour annuler ces frais.",
  "sodium": "Sodium",
  "softs": "Boissons gazeuses",
  "someItemsAreUnavailableMessage": "Certains produits dans votre panier ne sont pas disponibles en ce moment au restaurant sélectionné. Veuillez supprimer ces sélections et réessayer.",
  "someItemsNotAvailable": "Certains produits ne sont pas offerts",
  "somethingMissingHere": "Il manque quelque chose ici",
  "somethingWentWrong": "Quelque chose n'a pas bien fonctionné",
  "somethingWentWrongRemovingAddress": "Une erreur s'est produite lors de la suppression de l'adresse. Veuillez réessayer.",
  "somethingWrong": "Quelque chose n'a pas fonctionné",
  "sorrySomethingWentWrong": "Désolé, une erreur est survenue!",
  "soy": "soja",
  "specialOffers": "Offres Spéciales",
  "staffing": "Personnel",
  "standardsOfBusinessPractices": "Normes de pratiques commerciales",
  "startChallenge": "Commencez le défi",
  "startEarningRewards": "Commencez à accumuler des récompenses",
  "startNow": "Commencer maintenant",
  "startOrder": "Débuter une commande",
  "startOver": "Vous voulez recommencer?",
  "startOverDisclaimer": "Si vous choisissez de recommencer, votre panier sera vidé et vous commencerez une nouvelle commande.",
  "startOverInX": "Recommencez dans {timeRemaining}",
  "startPlayingMessage": "Vous pouvez maintenant commencer à jouer!",
  "startYourOrderHerePart1": "Commencez votre",
  "startYourOrderHerePart2": "commande ici",
  "state": "État",
  "stateIsARequiredField": "Vous devez entrer un État",
  "stillThere": "Toujours là?",
  "storeAddress": "{name}{conditionalLinebreak}{address1}{linebreak}{city}, {stateProvince} {postalCode}",
  "storeClosed": "LE RESTAURANT QUE VOUS AVEZ SÉLECTIONNÉ N'EST PAS OUVERT EN CE MOMENT.",
  "storeConfirmationCurbside": "Bordure à {location}",
  "storeConfirmationDelivery": "Livraison à {location}",
  "storeConfirmationDriveThru": "Drive Thru à {location}",
  "storeConfirmationEatIn": "Dîner à {location}",
  "storeConfirmationPickup": "Retirer à {location}",
  "storeConfirmationTakeout": "Commande à emporter à {location}",
  "storeCurrentlyClosed": "Le restaurant est présentement fermé",
  "storeDoesNotHaveMobileOrdering": "Ce restaurant n'a pas de commande mobile.",
  "storeInfo": "Infos et photos",
  "storeInfoAssistive": "Voir les informations pour ce restaurant",
  "storeIsClosingError": "Ce restaurant ferme bientôt et n’accepte pas les commandes mobiles.",
  "storeLocations": "Emplacement des restaurants",
  "storeLocator": "Localisateur de restaurant",
  "storeLocatorEmptyStateDefaultBody": "Rechercher un restaurant à proximité.",
  "storeLocatorEmptyStateDefaultTitle": "Trouver un restaurant",
  "storeLocatorEmptyStateFavoritesErrorBody": "Il semble qu'il y a eu un problème de notre côté. Essayez de recharger la page ou recherchez l'adresse dans l'onglet À proximité.",
  "storeLocatorEmptyStateFavoritesErrorTitle": "Oh ! Désolé.",
  "storeLocatorEmptyStateFavoritesNoAuthBody": "Pour enregistrer un restaurant dans vos favoris, ouvrez d’abord une session ou créez un compte.",
  "storeLocatorEmptyStateFavoritesNoAuthTitle": "Connectez-vous pour créer des favoris",
  "storeLocatorEmptyStateFavoritesNoStoresBody": "Appuie sur le cœur d'un restaurant pour l'enregistrer en tant que favori.",
  "storeLocatorEmptyStateFavoritesNoStoresTitle": "Nous n’avons pas trouvé de favoris",
  "storeLocatorEmptyStateNearbyErrorBody": "Il semble qu'il y a eu un problème de notre côté. Essayez de saisir l'adresse ou de trouver votre emplacement sur la carte.",
  "storeLocatorEmptyStateNearbyErrorTitle": "Oh ! Désolé.",
  "storeLocatorEmptyStateNearbyNoLocationBody": "Partage ta position pour que nous puissions te recommander des restaurants à proximité.",
  "storeLocatorEmptyStateNearbyNoLocationTitle": "Oups!",
  "storeLocatorEmptyStateNearbyNoStoresBody": "Aucun restaurant à proximité n’est disponible pour le moment. Essayez avec une autre adresse ou une autre ville.",
  "storeLocatorEmptyStateNearbyNoStoresTitle": "Nous n’avons pas trouvé de restaurants à proximité",
  "storeLocatorEmptyStateRecentErrorBody": "Il semble qu'il y a eu un problème de notre côté. Essayez de recharger la page ou recherchez l'adresse dans l'onglet À proximité.",
  "storeLocatorEmptyStateRecentErrorTitle": "Oh ! Désolé.",
  "storeLocatorEmptyStateRecentNoAuthBody": "Ouvrez d’abord une session ou créez un compte.",
  "storeLocatorEmptyStateRecentNoAuthTitle": "Ouvrez une session pour voir les restaurants récents",
  "storeLocatorEmptyStateRecentNoStoresBody": "Nous n’avons pas trouvé de restaurants récents. Changeons ça! Essaie d’entrer une adresse et de passer une commande.",
  "storeLocatorEmptyStateRecentNoStoresTitle": "Oh! Un moment",
  "storeNoOrderingBody": "Sélectionnez un autre emplacement ou venez nous voir en personne pour passer cette commande",
  "storeNoOrderingHeading": "LE RESTAURANT SÉLECTIONNÉ N’ACCEPTE PAS LES COMMANDES MOBILES EN CE MOMENT",
  "storeUnavailable": "Restaurant non disponible",
  "streetAddress": "Addresse",
  "submit": "Soumettre",
  "submitAnswer": "Dérrrouler maintenant",
  "submitEmail": "Soumettez votre adresse courriel",
  "submitFeedback": "Soumettre un commentaire",
  "subtotal": "Sous-total",
  "success": "C'est fait!",
  "successfulCardDeactivation": "Votre carte a bien été désactivée et votre carte numérique a été mise à jour",
  "successfullyCreatedSupportCase": "Votre demande de soutien a bien été soumise!",
  "successfullyUpdatedUserAccountInfo": "Les informations du compte ont été mises à jour.",
  "sugar": "Sucres",
  "sulphurDioxide": "dioxyde de soufre",
  "sunday": "Dimanche",
  "support": "Soutien",
  "supportFormDeliveryActive": "La commande semble ne pas avoir encore été livrée; si vous avez encore besoin d’aide, veuillez nous contacter ci-dessous.",
  "supportFormOrderAlreadyRefunded": "Vous semblez avoir déjà reçu un remboursement pour cette commande; si vous avez encore besoin d’aide, veuillez nous contacter ci-dessous.",
  "supportFormRefundGenericError": "Nous sommes vraiment désolés qu’un problème soit survenu avec votre commande; veuillez décrire le problème ci-dessous.",
  "supportFormSelectIssue": "Sélectionnez votre problème",
  "supportSubcategoryTitle": "Problème : {category}",
  "supportTopics": "Sujets liés au soutien",
  "supportTopicsAll": "Tous les sujets de soutien",
  "surprise": "surprise",
  "swipe": "Glisser la carte",
  "takeAdvantageOfLoyaltyProgram": "Profitez de notre programme de fidélisation",
  "takeOut": "À emporter",
  "takeOutComingSoon": "À emporter BIENTÔT DISPONIBLE",
  "takeOutUnavailable": "L'option à emporter n'est pas disponible pour le moment",
  "tapImClose": "Appuyez sur « Je suis à proximité » quand vous êtes à 5 minutes pour que nous puissions préparer votre commande. Votre carte ne sera pas débitée d’ici là.",
  "tapImCloseCashPayment": "Appuyez sur « Je suis tout près » 5 minutes avant d’arriver afin que nous puissions préparer votre commande.",
  "tapImHere": "Appuyez sur « Je suis ici » à votre arrivée pour que nous puissions préparer votre commande. Votre carte ne sera facturée qu'à ce moment-là.",
  "tapImHereCashPayment": "Appuyez sur « Je suis ici » lorsque vous arrivez afin que nous puissions préparer votre commande.",
  "tapToOrder": "Tapez pour commander",
  "tapToSeeDetails": "Tapez pour consulter d'autres détails.",
  "tapWhenHere": "Tapez lors de votre arrivée",
  "tastySwaps": "Échanges savoureux",
  "tax": "Taxes",
  "taxes": "Les taxes",
  "taxesAndFees": "Taxes et Frais",
  "taxesAndFeesButtonAriaLabel": "Afficher les taxes et les frais",
  "taxesAndFeesNextStep": "Calculés à l’étape finale",
  "tenMin": "10 min",
  "termsAccessibilityLabel": "Consultez les conditions pour {cardTitle}",
  "termsConditions": "Conditions",
  "termsConditionsRewards": "Modalites et Conditions FideliTim",
  "termsOfService": "Conditions de Service",
  "termsOfUse": "Conditions d'utilisation",
  "th.acceptEmailsAndSpecialOffers": "Oui! Je souhaite recevoir des courriels promotionnels concernant des offres spéciales et d'autres renseignements sur Tim Hortons. (Optionnel)",
  "thDirectPayOnboardingText": "Vous pouvez maintenant payer directement à l'aide de votre carte de crédit ou de débit. Vous devrez confirmer les détails de votre carte si vous sélectionnez une carte déjà enregistrée.",
  "thDirectPayOnboardingTitle": "Nouveau mode de paiement!",
  "thTimsRewards": "FidéliTim",
  "th_optInOutRewards": "« Nous vous enverrons des messages sur FidéliTim pour vous informer des nouveautés au sujet du programme et des nouvelles récompenses. Cela inclut l’envoi régulier d’offres spéciales personnalisées qui vous permettront d'accumuler plus de points et d'économiser de l’argent.",
  "thankYou": "Merci!",
  "theEmailAddressIsInvalid": "L’adresse courriel que vous avez indiquée n’est pas valide ou n’existe pas. Veuillez réessayer avec une adresse courriel valide, ou contactez le service d’assistance.",
  "thereAreErrorsInThisForm": "Il y a {numberOfErrors} erreurs dans ce formulaire",
  "thereIsAnErrorInThisForm": "Il y a une erreur dans ce formulaire",
  "theseAreOurFavorite": "Ce sont nos préférés",
  "thisMayTakeAFewSeconds": "Cela peut prendre quelques secondes",
  "thursday": "Jeudi",
  "timCard": "Carte Tim",
  "timCardInstructions": "Vous pouvez utiliser votre Carte Tim pour payer tous vos achats en ligne et en restaurant.",
  "timCardScanErrorBody": "Le code à barres que vous avez numérisé n’est pas un code à barres de Carte Tim. Voulez-vous essayer un code à barres différent?",
  "timCardScanErrorHeading": "Cela ne ressemble pas à une Carte Tim.",
  "timHortons": "Tim Hortons",
  "time": "Heure",
  "timeline": "Historique",
  "timing": "Timing",
  "tims": "Tim",
  "timsCampDonation": "Don aux Camps Tim Hortons",
  "timsCard": "Votre carte FidéliTim",
  "timsCardHeader": "Carte Tim",
  "timsCardLostOrStolen": "Si votre carte FidéliTim est perdue ou volée, vous pouvez la désactiver et la supprimer de votre compte. Vous recevrez une nouvelle carte numérique pour continuer à accumuler des récompenses. {linebreak} Ne vous inquiétez pas, toutes vos transactions et vos récompenses seront sauvegardées dans votre compte.",
  "timsMenu": "Menu de Tim",
  "timsRewards": "FidéliTim",
  "timsRewardsDetails": "FidéliTim détails",
  "timsRewardsFaqLinkText": "En savoir plus",
  "timsRewardsHeader": "FidéliTim",
  "timsRewardsTermsAndConditions": "Modalites et Conditions FideliTim",
  "tip": "Pourboire",
  "tipAmountError": "Veuillez utiliser un caractère numérique.",
  "tipAmountMaxError": "Ne doit pas excéder le sous-total ou 50 $.",
  "tipField": "Entrez un montant pour le pourboire (dollars)",
  "titleAllowLocation": "Votre emplacement n'est pas disponible",
  "to": "à",
  "toAddress": "à {address}",
  "toEarnRolls": "pour obtenir des rebords",
  "toggleMenu": "Basculer le menu",
  "togglePromoCode": "Entrez le code ici",
  "togglePromoCodeAria": "Cliquez ici pour ajouter un code promotionnel",
  "tooManyAddAccountAttempts": "Vous avez essayé d’ajouter un mode de paiement trop de fois en peu de temps. Veuillez réessayer plus tard.",
  "topLevelUnlocked": "Bravo, {userName} ! Tu as débloqué le niveau supérieur !",
  "total": "Total",
  "totalAmountAdded": "Montant total ajouté",
  "totalFat": "Total des lipides",
  "track": "Suivre",
  "trackOrder": "Suivre la commande",
  "trademarkAndCopyright": "MC et © {year} Burger King Company LLC.",
  "trademarkAndCopyrightPopeyes": "TM & © 2021 Popeyes Louisiana Kitchen, Inc.",
  "trademarks": "Marques de commerce",
  "transFat": "Lipides trans",
  "transferBalance": "Transférer le solde",
  "transferBalanceDirections": "Commencez par entrer les chiffres au dos de la carte pour consulter votre solde.",
  "transferBalanceError": "Nous n'avons pas pu traiter votre demande. Veuillez réessayer ou appuyer sur {link} pour obtenir de l'aide.",
  "transferBalanceFromAnotherTimCard": "Transférer le solde d'une autre Carte Tim",
  "transferBalanceFromTimCard": "Transférer le solde d'une Carte Tim",
  "transferSuccessful": "Transfert réussi",
  "transferXToMyGiftCard": "Transférer {balance} vers ma Carte Tim",
  "treatYourself": "Offrez-vous",
  "treeNuts": "noix",
  "trending": "Choix populaires",
  "troubleLoadingOrder": "Nous semblons avoir eu de la difficulté à traiter votre commande. Veuillez réessayer ou recommencer.",
  "tryAgain": "Essayer à nouveau",
  "tryingToEnterPromoCode": "Vous voulez entrer un code promotionnel? Entrez-le {below}.",
  "tuesday": "Mardi",
  "twelveDaysOfTims": "12 jours de Tim",
  "twentyMin": "20 min",
  "uhoh": "Oh non...",
  "unableToLoadTimCardNoInternet": "Unable to load TimCard, please connect to internet.",
  "unableToPlaceOrder": "Impossible de passer la commande",
  "unableToProcessOrder": "Impossible de traiter la commande",
  "unableToReloadCardError": "Nous n’avons pas pu réapprovisionner votre carte.",
  "unauthenticatedFavoritesHeader": "Connectez-vous pour sauvegarder des favoris.",
  "unauthenticatedFavoritesSubtext": "Inscrivez-vous ou connectez-vous pour sauvegarder vos favoris.",
  "unauthenticatedRecentItemsHeader": "Connectez-vous pour voir les articles récents.",
  "unauthenticatedRecentItemsSubtext": "Connectez-vous ou créez un compte pour voir vos articles récents.",
  "unavailable": "Non disponible",
  "unavailableAtLocation": "Non disponible à cet emplacement",
  "unit": "Unité",
  "unitNumber": "Unité {unitNumber}",
  "unitNumberInput": "Unité",
  "unitNumberLabel": "Unité (Optionnel)",
  "unitNumberLabelRequired": "Unité (Requis)",
  "unitedKingdom": "Royaume-Uni",
  "unitedStates": "États Unis",
  "unlock": "Déverrouiller",
  "unregisterYourCard": "Vous pouvez supprimer votre carte à tout moment dans les paramètres du compte.",
  "unsavedChangesBody": "Vous avez apporté des modifications à cette adresse. Voulez-vous les enregistrer avant de quitter ?",
  "unsavedChangesHeading": "Modifications non enregistrées",
  "unsavedChangesModalDescription": "Vous avez apporté des changements au produit. Voulez-vous sauvegarder?",
  "unsavedChangesModalHeader": "Changements non sauvegardés",
  "unsupportedCardType": "Désolé, nous n'acceptons pas {cardType} pour le moment.",
  "until": "jusqu'à",
  "unverified": "Non vérifié",
  "unverifiedCard": "Carte non vérifiée",
  "unwrapping": "Déroulement en cours…",
  "upateAddress": "Mettre à jour l'adresse",
  "update": "Mettre à jour",
  "updateBrowserLocationSettings": "Veuillez autoriser la géolocalisation dans les paramètres de votre navigateur et de votre système d’exploitation.",
  "updateCart": "Mettre à jour votre commande",
  "updateCartSuccess": "{itemName} mis à jour dans le panier.",
  "updateDeviceLocationSettings": "Dans les paramètres de votre dispositif veuillez autoriser l'accès de l'appli {brand} à votre localisation.",
  "updateInfoError": "Une erreur s’est produite durant la mise à jour de vos renseignements.",
  "updateItem": "Actualiser le produit",
  "updateLater": "Mettre à jour plus tard",
  "updateNow": "Mettre à jour maintenant",
  "updatePaymentMethod": "Mise à jour du mode de paiement",
  "updateQuantityAndItemWithPrice": "Mettre à jour {quantity} {itemName} pour {price}",
  "updateRewardLevel": "Mettre à jour",
  "uponOrderDelivery": "Lors de la livraison de la commande",
  "uponOrderPickup": "Lors de pickup de la commande",
  "upsellItemLabel": "{itemName} {calories} {price}",
  "us-calories": "Calories",
  "us-carbohydrates": "Glucides",
  "us-cholesterol": "Cholestérol",
  "us-fat": "Acide gras",
  "us-fiber": "Fibre",
  "us-proteins": "Protéines",
  "us-salt": "Sel",
  "us-saturatedFat": "Acide gras saturé",
  "us-sodium": "Sodium",
  "us-sugar": "Sucre",
  "us-transFat": "Acide gras trans",
  "us-weight": "Poids",
  "useCodeAtCashier": "Utiliser le code à la caisse",
  "useDifferentAddress": "Utiliser une adresse différente",
  "useRewards": "Mon niveau de récompenses",
  "useSavedAddressPhone": "Utiliser l'adresse et le numéro de téléphone sauvegardés",
  "usedAllCoupons": "On dirait que vous avez utilisé tous les coupons actuels.\nNos mises à jour sont récurrentes alors faites attention aux nouveaux.\nMerci pour votre fidélité.",
  "userAwayFromStore": "Vous semblez être bien loin.",
  "userDoesNotExist": "Cet utilisateur n'existe pas",
  "validationCode": "Code de validation",
  "validationError": "Une erreur s'est produite lors de la création de votre commande Veuillez réessayer",
  "validationErrorHeading": "Erreur de commande",
  "verified": "Vérifié",
  "verify": "Vérifier",
  "verifyEmailForRewards": "Vérifiez votre courriel pour lier une carte physique",
  "verifyNow": "Vérifiez maintenant",
  "verifyYourEmail": "Confirmer courriel",
  "verifyYourEmailInstructions": "Pour avoir accès à toutes les fonctionnalités de votre compte, veuillez consulter le courriel.",
  "view": "Afficher",
  "viewAll": "Voir tout",
  "viewAllOffers": "Voir toutes les offres",
  "viewCart": "Consulter le panier",
  "viewDetails": "Voir les détails",
  "viewDetailsWithOrderNumber": "Voir les détails de la commande numéro {ticketNumber}",
  "viewHistory": "Voir l'historique",
  "viewMenu": "Voir le menu",
  "viewOffers": "Voir les offres",
  "viewOrder": "Passer à la caisse",
  "viewOrderWithDescription": "Voir la commande {orderDesc}",
  "viewPurchasesAndOffers": "Consultez tous vos achats ici, y compris les Couronnes accumulées et réclamées.",
  "viewReceipt": "Voir le reçu",
  "viewRecentOrders": "Voir les commandes récentes",
  "viewTerms": "Conditions",
  "viewYourPurchases": "Consultez ici tous vos achats,\ny compris les Couronnes gagnées et échangées.",
  "visitSupport": "Centre de soutien",
  "visitSupportForHelpWithYourCurrentOrder": "Visitez le centre de soutien pour obtenir de l'aide avec votre commande actuelle.",
  "visitSupportForHelpWithYourOrder": "Visitez le centre de soutien pour obtenir de l'aide avec votre commande.",
  "visits": "Visites",
  "visitsAwayFromReward": " visites avant votre prochaine récompense",
  "visuallyHiddenOpenInAppOrBrowser": "Veuillez cliquer sur le bouton Ouvrir l’appli pour accéder à l’application mobile. Si vous voulez accéder au site Web, cliquez sur le bouton Continuer sur le site Web. Cela enverra un autre code d’ouverture de session que vous pourrez utiliser pour accéder au site Web.",
  "visuallyHiddenSelectItem": "Sélectionner {itemName}",
  "visuallyHiddenSignInCodeSentToEmail": "Nous avons envoyé un code de connexion à 6 chiffres à votre adresse courriel. Veuillez saisir le code dans le champ approprié.",
  "visuallyHiddenSignInSuccess": "Vous avez ouvert une session avec succès!",
  "visuallyHiddenVerifyingOTP": "Nous vérifions",
  "voucherCodeError": "Veuillez entrer un code promotionnel",
  "voucherNotFound": "Code promotionnel non valide ou expiré. Vous voulez associer votre carte physique? Entrez son numéro {above}.",
  "voucherUsed": "Ce code promotionnel a déjà été utilisé",
  "waitForReply": "Surveillez votre boîte de réception – nous répondons généralement dans les 24 à 48 heures.",
  "wayToGo": "Bravo ! Il est temps d’échanger",
  "waysToOrder": "Façons de commander",
  "weArePreparingYourOrder": "Nous préparons votre commande et la placerons sur le comptoir avant lorsqu’elle sera prête.",
  "weCantWaitToServeYou": "Nous avons hâte de vous servir",
  "weFoundStoreCloserToYou": "Nous avons trouvé un restaurant plus près de chez vous",
  "weHadToRemoveUnavailableItems": "Nous avons dû retirer certains produits qui ne sont pas offerts dans ce restaurant\n",
  "weHaveSelectedClosestStore": "Nous avons sélectionné le restaurant le plus près d'où vous vous trouvez.",
  "weWillCallNameWhenYourOrderIsReady": "Nous appellerons {name} lorsque votre commande sera prête. ",
  "weWillEmailYouWithOrderStatus": "Nous vous enverrons un e-mail avec l'état de la commande une fois que nous aurons reçu des nouvelles du restaurant.",
  "weWillPrepareYourOrderAtTime": "Nous préparerons votre commande à {time}.",
  "wednesday": "Mercredi",
  "weight": "Poids",
  "welcomeBack": "C’est un plaisir de vous revoir!",
  "welcomeToBkLoyalty": "Bienvenue à la nouvelle BK Loyalty",
  "welcomeToYour": "Bienvenue sur votre",
  "whatDoYouNeedHelpWith": "En quoi pouvons-nous vous aider ?",
  "whatIsNew": "Quoi de neuf",
  "whatIsTheIssue": "Quel est le problème?",
  "whatWouldYouLikeToContactUsAbout": "À quel sujet aimeriez-vous nous contacter?",
  "wheat": "blé",
  "whoops": "Oups!",
  "whyDoYouNeedMyPhoneNumber": "Pourquoi avez-vous besoin de mon numéro de téléphone ?",
  "willPickUpOrder": "Comment vas-tu récupérer ta commande?",
  "willSendConfirmationTo": "Nous enverrons un courriel de confirmation à",
  "willSendYourRequestedInfoTo": "Nous vous enverrons l’information que vous avez demandée par courriel à {email}. Veuillez allouer environ une semaine pour le déroulement complet de ce processus.",
  "winners": "Gagnants",
  "withYourDigitalTimCard": "avec votre Carte Tim numérique",
  "work": "Travail",
  "wouldYouLikeToUseOneNowFreeItem": "Voulez-vous en réclamer une maintenant pour obtenir l’un de vos produits gratuitement?",
  "wow": "OUAH !",
  "xItems": "{xItems, plural, zero {} one {# produit} two {} few {} many {} other {# produits}}",
  "xMoreOrders": "Vous êtes sur la bonne voie! Encore {pointsUntil} visites avant d'obtenir un produit gratuit.",
  "yay": "Bien!",
  "year": "Année",
  "yearPlaceholder": "AAAA",
  "yes": "Oui",
  "youCanPayWithACardRightHere": "Vous pouvez payer avec une carte ici même!",
  "youCompletedYourMonthlyAndProfileChallenges": "Vous avez complété avec succès votre défi du profil\net votre défi mensuel.",
  "youCompletedYourMonthlyChallenge": "Vous avez complété avec succès votre\ndéfi mensuel.",
  "youCompletedYourProfileChallenge": "Vous avez complété avec succès votre\ndéfi du profil.",
  "youCurrentlyHaveXRewards": "Vous avez actuellement {availableRedemptions} récompenses",
  "youHave": "Vous avez",
  "youHaveNumAvailableRewards": "Vous avez {availableRedemptions} récompenses.",
  "youHaveQuantityItemInCart": "Vous avez maintenant {itemQuantity}-{itemName} dans votre panier.",
  "youHaveSuccessfullySubmittedTheForm": "Votre formulaire a bien été envoyé",
  "youHaveXPoints": "VOUS AVEZ {pointsNumber} POINTS",
  "youQualifyFreeDelivery": "Vous avez droit à la livraison gratuite!",
  "youWillBeCharged": "Vous serez facturé {reloadAmount}",
  "yourAddress": "Ton Adresse",
  "yourBalanceXAddY": "Votre solde actuel est de {currentBalance}. Souhaitez-vous ajouter {balanceToAdd} sur votre Carte Tim?",
  "yourCardHasBeenCharged": "Votre carte a été débitée. Vous recevrez une confirmation par e-mail dans les 24 heures.",
  "yourCardHasBeenSuccessfullyRegistered": "Votre carte a été enregistrée avec succès.",
  "yourCart": "Ton panier",
  "yourClosestStore": "Votre Restaurant le Plus Près",
  "yourClosestStoreX": "Le restaurant le plus près est {storeAddress}",
  "yourCourier": "Ton livreur",
  "yourCrownOrders": "Vos commandes",
  "yourCurrentTimsRewardCardNumberIs": "Numéro de votre carte FidéliTim {userAccountNumber}",
  "yourEmail": "Votre courriel",
  "yourFavorites": "Favoris",
  "yourFullName": "Votre Nom et Prénom",
  "yourLeastExpensiveItemFree": "Votre produit le moins dispendieux dans cette commande sera gratuit!",
  "yourLocationCannotAcceptDelivery": "Nous sommes désolés, votre restaurant ne peut pas accepter les commandes de livraison en ce moment.",
  "yourName": "votre nom",
  "yourNewBalanceX": "Le nouveau solde de votre Carte Tim est de {newBalance}",
  "yourNewPaymentMethodHasBeenSuccessfullySaved": "Votre nouvelle méthode de paiement a bien été sauvegardée",
  "yourOrder": "Votre commande",
  "yourOrderHasBeenPlaced": "Votre commande a été passée en ligne avec celles d'autres clients et sera prête dès que possible!",
  "yourOrderIsBeingConfirmed": "Votre commande est en cours de confirmation!",
  "yourOrderIsConfirmed": "Votre commande est confirmée!",
  "yourPointsWillExpire": "Vos Couronnes expireront le",
  "yourRewards": "Vos récompenses",
  "yourRewardsAccountNumber": "Votre numéro de compte FidéliTim",
  "yourSelectedPaymentMethodIsTimCard": "La méthode de paiement que vous avez choisie est la carte Tim",
  "yourSelectedRestaurantIs": "Vous avez sélectionné le restaurant suivant : {storeAddress}",
  "yourSelectedStore": "Votre restaurant sélectionné",
  "yourTimCardBalance": "Votre solde d'une Carte Tim",
  "yourTimsRewardsNumber": "Votre carte FidéliTim",
  "yourUpdateIsntSavedYetBody": "Votre mise à jour du niveau de récompense vers {selectedTierName} n’a pas encore été enregistrée. Sélectionnez mettre à jour le niveau de récompense.",
  "yourUpdateIsntSavedYetHeading": " Votre mise à jour n’a pas encore été enregistrée.",
  "yourWay": "À ton goût : ",
  "yourXPointsAway": "Il vous manque {points} ",
  "youreXAwayFromFreeDelivery": "Il vous manque {amount} pour obtenir la livraison gratuite!",
  "youveEarnedAFreeItem": "Vous avez obtenu un produit gratuit!",
  "youveGotEnoughCrowns": "Assez de couronnes",
  "zipCode": "Code Postal",
  "zipCodeError": "Veuillez entrer un code postal canadien, américain ou britannique valide",
  "zipCodeInvalid": "Code postal non valide",
  "zipCodeRequiredError": "Vous devez entrer un code postal"
}
